// This file is auto-generated. Do not edit manually.
// Run "npm run -w packages/iconik-api generate" to regenerate.
/** biome-ignore-all lint/complexity/noBannedTypes: some API definitions are unclear */
import { httpMethod } from '../constants';
import type { IconikApiHeaders } from '../types';
import type {
  AssetsAssetElasticSchema,
  AssetsAssetElasticSchemaWithIdNullable,
  AssetsCollectionElasticSchema,
  AssetsCollectionElasticSchemaWithIdNullable,
} from './assets';

export const SearchHttpPutDiscoveryDefault =
  'SearchHttpPutDiscoveryDefault' as const;
export const SearchHttpGetDiscoveryDefaultEntities =
  'SearchHttpGetDiscoveryDefaultEntities' as const;
export const SearchHttpPostDiscoveryDefaultEntities =
  'SearchHttpPostDiscoveryDefaultEntities' as const;
export const SearchHttpGetDiscoveryDefaultEntitiesAdmin =
  'SearchHttpGetDiscoveryDefaultEntitiesAdmin' as const;
export const SearchHttpDeleteDiscoveryDefaultEntitiesByEntityId =
  'SearchHttpDeleteDiscoveryDefaultEntitiesByEntityId' as const;
export const SearchHttpGetDiscoveryDefaultEntitiesByEntityId =
  'SearchHttpGetDiscoveryDefaultEntitiesByEntityId' as const;
export const SearchHttpPatchDiscoveryDefaultEntitiesByEntityId =
  'SearchHttpPatchDiscoveryDefaultEntitiesByEntityId' as const;
export const SearchHttpPutDiscoveryDefaultEntitiesByEntityId =
  'SearchHttpPutDiscoveryDefaultEntitiesByEntityId' as const;
export const SearchHttpPatchDiscoveryEntitiesByObjectTypeByObjectId =
  'SearchHttpPatchDiscoveryEntitiesByObjectTypeByObjectId' as const;
export const SearchHttpPutDiscoveryEntitiesByObjectTypeByObjectId =
  'SearchHttpPutDiscoveryEntitiesByObjectTypeByObjectId' as const;
export const SearchHttpDeleteFavorites = 'SearchHttpDeleteFavorites' as const;
export const SearchHttpPostFavorites = 'SearchHttpPostFavorites' as const;
export const SearchHttpPostNltfParse = 'SearchHttpPostNltfParse' as const;
export const SearchHttpPostSearch = 'SearchHttpPostSearch' as const;
export const SearchHttpPostSearchContentInfo =
  'SearchHttpPostSearchContentInfo' as const;
export const SearchHttpPostSearchConvertToCollection =
  'SearchHttpPostSearchConvertToCollection' as const;
export const SearchHttpGetSearchHistory = 'SearchHttpGetSearchHistory' as const;
export const SearchHttpDeleteSearchHistoryBySearchHistoryId =
  'SearchHttpDeleteSearchHistoryBySearchHistoryId' as const;
export const SearchHttpGetSearchHistoryBySearchHistoryId =
  'SearchHttpGetSearchHistoryBySearchHistoryId' as const;
export const SearchHttpGetSearchSaved = 'SearchHttpGetSearchSaved' as const;
export const SearchHttpPostSearchSaved = 'SearchHttpPostSearchSaved' as const;
export const SearchHttpPostSearchSavedGroup =
  'SearchHttpPostSearchSavedGroup' as const;
export const SearchHttpDeleteSearchSavedGroupByGroupId =
  'SearchHttpDeleteSearchSavedGroupByGroupId' as const;
export const SearchHttpGetSearchSavedGroupByGroupId =
  'SearchHttpGetSearchSavedGroupByGroupId' as const;
export const SearchHttpPatchSearchSavedGroupByGroupId =
  'SearchHttpPatchSearchSavedGroupByGroupId' as const;
export const SearchHttpPutSearchSavedGroupByGroupId =
  'SearchHttpPutSearchSavedGroupByGroupId' as const;
export const SearchHttpDeleteSearchSavedGroupByGroupIdSearchBySearchId =
  'SearchHttpDeleteSearchSavedGroupByGroupIdSearchBySearchId' as const;
export const SearchHttpPostSearchSavedGroupByGroupIdSearchBySearchId =
  'SearchHttpPostSearchSavedGroupByGroupIdSearchBySearchId' as const;
export const SearchHttpGetSearchSavedGroups =
  'SearchHttpGetSearchSavedGroups' as const;
export const SearchHttpPostSearchSavedGroupsByGroupIdReindex =
  'SearchHttpPostSearchSavedGroupsByGroupIdReindex' as const;
export const SearchHttpDeleteSearchSavedBySearchId =
  'SearchHttpDeleteSearchSavedBySearchId' as const;
export const SearchHttpGetSearchSavedBySearchId =
  'SearchHttpGetSearchSavedBySearchId' as const;
export const SearchHttpPatchSearchSavedBySearchId =
  'SearchHttpPatchSearchSavedBySearchId' as const;
export const SearchHttpPutSearchSavedBySearchId =
  'SearchHttpPutSearchSavedBySearchId' as const;
export const SearchHttpGetSearchSavedBySearchIdContentInfo =
  'SearchHttpGetSearchSavedBySearchIdContentInfo' as const;
export const SearchHttpPostSearchSavedBySearchIdConvertToCollection =
  'SearchHttpPostSearchSavedBySearchIdConvertToCollection' as const;
export const SearchHttpPostSearchSavedBySearchIdReindex =
  'SearchHttpPostSearchSavedBySearchIdReindex' as const;
export const SearchHttpPostSearchSuggest =
  'SearchHttpPostSearchSuggest' as const;
export const SearchHttpDeleteViews = 'SearchHttpDeleteViews' as const;
export const SearchHttpGetViews = 'SearchHttpGetViews' as const;
export const SearchHttpPostViews = 'SearchHttpPostViews' as const;
export const SearchHttpDeleteViewsByViewId =
  'SearchHttpDeleteViewsByViewId' as const;
export const SearchHttpGetViewsByViewId = 'SearchHttpGetViewsByViewId' as const;
export const SearchHttpPutViewsByViewId = 'SearchHttpPutViewsByViewId' as const;
export const SearchHttpPostV2NltfParse = 'SearchHttpPostV2NltfParse' as const;
export const SearchHttpGetV2Ping = 'SearchHttpGetV2Ping' as const;
export const SearchHttpPostV2Search = 'SearchHttpPostV2Search' as const;
export const SearchHttpPostV2SearchNatural =
  'SearchHttpPostV2SearchNatural' as const;
export const SearchHttpPostV2SearchSuggest =
  'SearchHttpPostV2SearchSuggest' as const;
export const SearchHttpGetV2SearchBackends =
  'SearchHttpGetV2SearchBackends' as const;
export const SearchHttpPostV2SearchBackends =
  'SearchHttpPostV2SearchBackends' as const;
export const SearchHttpGetV2SearchBackendsKinds =
  'SearchHttpGetV2SearchBackendsKinds' as const;
export const SearchHttpDeleteV2SearchBackendsByBackendId =
  'SearchHttpDeleteV2SearchBackendsByBackendId' as const;
export const SearchHttpGetV2SearchBackendsByBackendId =
  'SearchHttpGetV2SearchBackendsByBackendId' as const;
export const SearchHttpPatchV2SearchBackendsByBackendId =
  'SearchHttpPatchV2SearchBackendsByBackendId' as const;
export const SearchHttpPutV2SearchBackendsByBackendId =
  'SearchHttpPutV2SearchBackendsByBackendId' as const;
export const SearchHttpPostV2SearchBackendsByBackendIdTest =
  'SearchHttpPostV2SearchBackendsByBackendIdTest' as const;

/**
 * Original schema `FilterDisposition`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-FilterDisposition}
 */
export type SearchFilterDisposition = 'mandatory' | 'relaxable';
/**
 * Original schema `FilterModifier`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-FilterModifier}
 */
export type SearchFilterModifier =
  | 'include_any_of'
  | 'include_all_of'
  | 'exclude_any_of'
  | 'exclude_all_of';
/**
 * Original schema `FilterRole`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-FilterRole}
 */
export type SearchFilterRole = 'filter' | 'scoring';
/**
 * Original schema `Modality`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-Modality}
 */
export type SearchModality = 'visual' | 'spoken' | 'audio' | 'document';
/**
 * Original schema `ResultOrder`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-ResultOrder}
 */
export type SearchResultOrder = 'relevance' | 'recent';
/**
 * Original schema `RankingUnit`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-RankingUnit}
 */
export type SearchRankingUnit = 'asset' | 'segment' | 'collection' | 'post';
/**
 * Original schema `ScoringStage`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-ScoringStage}
 */
export type SearchScoringStage = 'fusion' | 'rerank';
/**
 * Original schema `SourceState`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SourceState}
 */
export type SearchSourceState =
  | 'ok'
  | 'partial'
  | 'timeout'
  | 'unavailable'
  | 'error';
/**
 * Original schema `PaginationRefusal`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-PaginationRefusal}
 */
export type SearchPaginationRefusal =
  | 'multiple_rounds'
  | 'external_backend'
  | 'unexpressible_query'
  | 'rerank_applied'
  | 'segment_result_unit'
  | 'no_results';
/**
 * Original schema `Tier`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-Tier}
 */
export type SearchTier = 'require' | 'try' | 'prefer';

/**
 * Original schema `AutomationSearchCriteriaSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-AutomationSearchCriteriaSchema}
 */
export interface SearchAutomationSearchCriteriaSchema {
  automation_ids: string[];
  doc_types?: (
    | 'assets'
    | 'collections'
    | 'segments'
    | 'saved_searches'
    | 'saved_search_groups'
  )[];
  execution_time?: string;
  filter?: SearchCriteriaFilter;
}
/**
 * Original schema `CriteriaFilter`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-CriteriaFilter}
 */
export interface SearchCriteriaFilter {
  filters?: SearchCriteriaFilter[];
  operator: string;
  /**
   * Nested field path. Required for the `NESTED` operator.
   */
  path?: string;
  terms?: SearchCriteriaTerm[];
}
/**
 * Original schema `CriteriaTerm`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-CriteriaTerm}
 */
export interface SearchCriteriaTerm {
  exists?: boolean;
  missing?: boolean;
  name: string;
  range?: SearchCriteriaRangeFilter;
  value?: string;
  value_in?: string[];
}
/**
 * Original schema `CriteriaRangeFilter`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-CriteriaRangeFilter}
 */
export interface SearchCriteriaRangeFilter {
  max?: string | null;
  min?: string | null;
  /**
   * Format: +02:00. Results returned in UTC by default
   */
  timezone?: string | null;
}
/**
 * Original schema `BaseQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-BaseQueryParamsSchema}
 */
export interface SearchBaseQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `BulkAddToFavoritesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-BulkAddToFavoritesSchema}
 */
export interface SearchBulkAddToFavoritesSchema {
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
}
/**
 * Original schema `BulkDeleteFromFavoritesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-BulkDeleteFromFavoritesSchema}
 */
export interface SearchBulkDeleteFromFavoritesSchema {
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
}
/**
 * Original schema `BulkSavedSearchActionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-BulkSavedSearchActionSchema}
 */
export interface SearchBulkSavedSearchActionSchema {
  job_id: string;
  search_ids: string[];
}
/**
 * Original schema `BulkSavedSearchFaceExtractionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-BulkSavedSearchFaceExtractionSchema}
 */
export interface SearchBulkSavedSearchFaceExtractionSchema {
  include_assets: boolean;
  include_collections: boolean;
  job_id: string;
  search_ids: string[];
}
/**
 * Original schema `BulkSavedSearchFilesDeleteSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-BulkSavedSearchFilesDeleteSchema}
 */
export interface SearchBulkSavedSearchFilesDeleteSchema {
  job_id: string;
  search_ids: string[];
  storage_id: string;
}
/**
 * Original schema `BulkSavedSearchMetadataUpdateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-BulkSavedSearchMetadataUpdateSchema}
 */
export interface SearchBulkSavedSearchMetadataUpdateSchema {
  include_assets: boolean;
  include_collections: boolean;
  job_id: string;
  search_ids: string[];
}
/**
 * Original schema `BulkSavedSearchObjectsACLUpdateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-BulkSavedSearchObjectsACLUpdateSchema}
 */
export interface SearchBulkSavedSearchObjectsACLUpdateSchema {
  include_assets: boolean;
  include_collections: boolean;
  job_id: string;
  search_ids: string[];
}
/**
 * Original schema `BulkSavedSearchObjectsAnalyzeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-BulkSavedSearchObjectsAnalyzeSchema}
 */
export interface SearchBulkSavedSearchObjectsAnalyzeSchema {
  job_id: string;
  search_ids: string[];
}
/**
 * Original schema `BulkSavedSearchObjectsDeleteSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-BulkSavedSearchObjectsDeleteSchema}
 */
export interface SearchBulkSavedSearchObjectsDeleteSchema {
  content_only?: boolean;
  include_assets: boolean;
  include_collections: boolean;
  job_id: string;
  search_ids: string[];
}
/**
 * Original schema `BulkSavedSearchObjectsMetadataFillingSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-BulkSavedSearchObjectsMetadataFillingSchema}
 */
export interface SearchBulkSavedSearchObjectsMetadataFillingSchema {
  job_id: string;
  search_ids: string[];
}
/**
 * Original schema `BulkSavedSearchObjectsSetApprovalSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-BulkSavedSearchObjectsSetApprovalSchema}
 */
export interface SearchBulkSavedSearchObjectsSetApprovalSchema {
  job_id: string;
  search_ids: string[];
}
/**
 * Original schema `BulkSavedSearchObjectsTranscodeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-BulkSavedSearchObjectsTranscodeSchema}
 */
export interface SearchBulkSavedSearchObjectsTranscodeSchema {
  job_id: string;
  search_ids: string[];
}
/**
 * Original schema `BulkSavedSearchObjectsTranscribeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-BulkSavedSearchObjectsTranscribeSchema}
 */
export interface SearchBulkSavedSearchObjectsTranscribeSchema {
  job_id: string;
  search_ids: string[];
}
/**
 * Original schema `BulkSavedSearchObjectsTransferSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-BulkSavedSearchObjectsTransferSchema}
 */
export interface SearchBulkSavedSearchObjectsTransferSchema {
  include_assets: boolean;
  include_collections: boolean;
  job_id: string;
  search_ids: string[];
}
/**
 * Original schema `BulkSavedSearchReindexSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-BulkSavedSearchReindexSchema}
 */
export interface SearchBulkSavedSearchReindexSchema {
  include_assets?: boolean;
  include_collections?: boolean;
  job_id: string;
  search_ids: string[];
}
/**
 * Original schema `ConnectionTestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-ConnectionTestSchema}
 */
export interface SearchConnectionTestSchema {
  message?: string;
  ok: boolean;
  supported: boolean;
}
/**
 * Original schema `CriteriaFilterSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-CriteriaFilterSchema}
 */
export interface SearchCriteriaFilterSchema {
  filters?: SearchCriteriaFilterSchema[];
  operator: string;
  /**
   * Nested field path. Required for the `NESTED` operator.
   */
  path?: string;
  terms?: SearchCriteriaTerm[];
}
/**
 * Original schema `CriteriaRangeFilterSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-CriteriaRangeFilterSchema}
 */
export interface SearchCriteriaRangeFilterSchema {
  max?: string;
  min?: string;
  /**
   * Format: +02:00. Results returned in UTC by default
   */
  timezone?: string;
}
/**
 * Original schema `CriteriaSortSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-CriteriaSortSchema}
 */
export interface SearchCriteriaSortSchema {
  name: string;
  order?: string;
}
/**
 * Original schema `CriteriaTermSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-CriteriaTermSchema}
 */
export interface SearchCriteriaTermSchema {
  exists?: boolean;
  missing?: boolean;
  name: string;
  range?: SearchCriteriaRangeFilterSchema;
  value?: string;
  value_in?: string[];
}
/**
 * Original schema `DiscoveryEntitiesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-DiscoveryEntitiesSchema}
 */
export interface SearchDiscoveryEntitiesSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: SearchDiscoveryEntity[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `DiscoveryEntity`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-DiscoveryEntity}
 */
export interface SearchDiscoveryEntity {
  date_created?: string;
  date_modified?: string;
  id?: string;
  metadata?: {
    [k: string]: unknown;
  };
  object_id: string;
  object_type: 'COLLECTION' | 'SAVED_SEARCH';
  title: string;
  user_id: string;
}
/**
 * Original schema `DiscoveryEntitySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-DiscoveryEntitySchema}
 */
export interface SearchDiscoveryEntitySchema {
  date_created?: string;
  date_modified?: string;
  id?: string;
  metadata?: {
    [k: string]: unknown;
  };
  object_id: string;
  object_type: 'COLLECTION' | 'SAVED_SEARCH';
  title: string;
  user_id: string;
}
/**
 * Original schema `DiscoveryViewSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-DiscoveryViewSettingsSchema}
 */
export interface SearchDiscoveryViewSettingsSchema {
  entity_ids: string[];
  id?: string;
  system_domain_id?: string;
}
/**
 * Original schema `ErrorResponse`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-ErrorResponse}
 */
export interface SearchErrorResponse {
  errors?:
    | string[]
    | {
        [k: string]: string[];
      };
}
/**
 * Original schema `Evidence`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-Evidence}
 */
export interface SearchEvidence {
  field?: string | null;
  /**
   * `text` — an excerpt of a field the query matched, the only kind that can point at where in a document the match landed. `clause` — a named structured clause matched ("exact file name"); there is no excerpt, only the name of what matched, in `location`. `rationale` — a backend's own account of why it returned the hit (a retrieved passage, a clip transcription), tied to no field of ours and carrying no markers.
   */
  kind?: 'text' | 'clause' | 'rationale';
  location?: string | null;
  /**
   * Which backend gave this account, as its internal key.
   */
  source?: string | null;
  /**
   * That backend's display name ("iconik", "TwelveLabs").
   */
  source_label?: string | null;
  text?: string | null;
}
/**
 * Original schema `FacetFilter`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-FacetFilter}
 */
export interface SearchFacetFilter {
  name: string;
  value_in?: string[] | null;
}
/**
 * Original schema `FacetFilterSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-FacetFilterSchema}
 */
export interface SearchFacetFilterSchema {
  name: string;
  value_in?: string[];
}
/**
 * Original schema `HTTPValidationError`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-HTTPValidationError}
 */
export interface SearchHTTPValidationError {
  detail?: SearchValidationError[];
}
/**
 * Original schema `ValidationError`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-ValidationError}
 */
export interface SearchValidationError {
  loc: (string | number)[];
  msg: string;
  type: string;
}
/**
 * Original schema `KeywordPredicate`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-KeywordPredicate}
 */
export interface SearchKeywordPredicate {
  kind?: 'keyword';
  negate?: boolean;
  op: 'eq' | 'in' | 'all' | 'range' | 'exists' | 'any_of';
  value:
    | string
    | number
    | boolean
    | SearchRangeBound
    | (
        | SearchRangeBound
        | (string | number | boolean)[]
        | string
        | number
        | boolean
      )[];
}
/**
 * Original schema `RangeBound`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-RangeBound}
 */
export interface SearchRangeBound {
  gt?: (string | number | boolean) | null;
  gte?: (string | number | boolean) | null;
  lt?: (string | number | boolean) | null;
  lte?: (string | number | boolean) | null;
}
/**
 * Original schema `KindDescriptorSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-KindDescriptorSchema}
 */
export interface SearchKindDescriptorSchema {
  kind: string;
  options_schema: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `KindsListSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-KindsListSchema}
 */
export interface SearchKindsListSchema {
  objects: SearchKindDescriptorSchema[];
}
/**
 * Original schema `ListObjectsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-ListObjectsSchema}
 */
export interface SearchListObjectsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `MatchAssessment`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-MatchAssessment}
 */
export interface SearchMatchAssessment {
  basis?: 'retrieval' | 'reranker' | 'judge';
  quality: 'exact' | 'related' | 'approximate' | 'filters_only';
  round_index?: number;
}
/**
 * Original schema `MultiSelectFilterGroup`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-MultiSelectFilterGroup}
 */
export interface SearchMultiSelectFilterGroup {
  items: string[];
  modifier: SearchFilterModifier;
}
/**
 * Original schema `MultiSelectFilterGroupSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-MultiSelectFilterGroupSchema}
 */
export interface SearchMultiSelectFilterGroupSchema {
  items?: string[];
  modifier?:
    | 'include_any_of'
    | 'include_all_of'
    | 'exclude_any_of'
    | 'exclude_all_of';
}
/**
 * Original schema `NaturalSearchDocument`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-NaturalSearchDocument}
 */
export interface SearchNaturalSearchDocument {
  date_created?: string | null;
  date_modified?: string | null;
  description?: string | null;
  /**
   * Why this hit matched: every account, from every source that found it, each naming its own `source`. Empty when nothing matched textually and the filters alone selected the hit — see `match`.
   */
  evidence?: SearchEvidence[];
  id?: string | null;
  /**
   * How this hit was retrieved, not how relevant it is: `quality` is `exact` when the query as typed matched, `related` when the query asked for what a result shows and it was matched by stand-in words, `approximate` when only a recovery round matched (fuzzed terms, a broadened phrase), and `filters_only` when no text matched and the filters alone selected it. `basis` names the evidence behind that verdict — `retrieval` today.
   */
  match?: SearchMatchAssessment | null;
  metadata?: {
    [k: string]: unknown;
  } | null;
  object_type: string;
  score?: number;
  /**
   * Matched moments within this hit, best first. Empty for a hit with no sub-structure, and always empty when `nested_results` is false.
   */
  segments?: SearchNaturalSearchSegment[];
  title: string;
}
/**
 * Original schema `NaturalSearchSegment`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-NaturalSearchSegment}
 */
export interface SearchNaturalSearchSegment {
  end_s?: number | null;
  /**
   * Why this moment matched: every account, from every source that found it. Empty when nothing matched textually — see `match`.
   */
  evidence?: SearchEvidence[];
  id: string;
  /**
   * How this hit was retrieved, not how relevant it is: `quality` is `exact` when the query as typed matched, `related` when the query asked for what a result shows and it was matched by stand-in words, `approximate` when only a recovery round matched (fuzzed terms, a broadened phrase), and `filters_only` when no text matched and the filters alone selected it. `basis` names the evidence behind that verdict — `retrieval` today.
   */
  match?: SearchMatchAssessment | null;
  score?: number;
  start_s?: number | null;
  thumbnail_s?: number | null;
}
/**
 * Original schema `NaturalSearchImage`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-NaturalSearchImage}
 */
export interface SearchNaturalSearchImage {
  asset_id: string;
  /**
   * How the reference image is matched: `visual` or `semantic`.
   */
  similarity?: 'semantic' | 'visual';
}
/**
 * Original schema `NaturalSearchMoment`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-NaturalSearchMoment}
 */
export interface SearchNaturalSearchMoment {
  /**
   * The asset this moment is part of; its key in `assets`.
   */
  asset_id: string;
  end_s?: number | null;
  /**
   * Why this moment matched: every account, from every source that found it. Empty when nothing matched textually — see `match`.
   */
  evidence?: SearchEvidence[];
  id: string;
  /**
   * How this hit was retrieved, not how relevant it is: `quality` is `exact` when the query as typed matched, `related` when the query asked for what a result shows and it was matched by stand-in words, `approximate` when only a recovery round matched (fuzzed terms, a broadened phrase), and `filters_only` when no text matched and the filters alone selected it. `basis` names the evidence behind that verdict — `retrieval` today.
   */
  match?: SearchMatchAssessment | null;
  score?: number;
  start_s?: number | null;
  thumbnail_s?: number | null;
}
/**
 * Original schema `NaturalSearchReplay`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-NaturalSearchReplay}
 */
export interface SearchNaturalSearchReplay {
  /**
   * The query to run. Each entry's `role` is honoured, so the block as received reproduces the same search; drop an entry to drop that filter.
   */
  applied?: SearchResponseFilterInput[];
  exact_text?: boolean;
  meaning_led?: boolean;
  order?: ('relevance' | 'recent') | null;
  ranking_unit?: ('asset' | 'segment' | 'collection' | 'post') | null;
  /**
   * The block's `version`. One this server no longer replays is a 400.
   */
  version: number;
}
/**
 * Original schema `ResponseFilter-Input`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-ResponseFilter-Input}
 */
export interface SearchResponseFilterInput {
  /**
   * Original schema `FilterDisposition`
   *
   * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-FilterDisposition}
   */
  disposition?: 'mandatory' | 'relaxable';
  facetable?: boolean;
  field: string;
  field_type?: string;
  label?: string | null;
  predicate:
    | SearchKeywordPredicate
    | SearchPublicLexicalPredicateInput
    | SearchPublicSemanticPredicateInput;
  pushed_down?: boolean;
  reason?: string | null;
  role?: SearchFilterRole | null;
  value_labels?: {
    [k: string]: string;
  };
  weight?: number;
}
/**
 * Original schema `PublicLexicalPredicate-Input`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-PublicLexicalPredicate-Input}
 */
export interface SearchPublicLexicalPredicateInput {
  any_of?: string[];
  fuzziness?: string | null;
  kind?: 'lexical';
  operator?: ('and' | 'or') | null;
  sub_field?: string | null;
  terms?: string;
  /**
   * Original schema `Tier`
   *
   * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-Tier}
   */
  tier?: 'require' | 'try' | 'prefer';
}
/**
 * Original schema `PublicSemanticPredicate-Input`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-PublicSemanticPredicate-Input}
 */
export interface SearchPublicSemanticPredicateInput {
  kind?: 'semantic';
  text: string;
  /**
   * Original schema `Tier`
   *
   * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-Tier}
   */
  tier?: 'require' | 'try' | 'prefer';
}
/**
 * Original schema `NaturalSearchRequest`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-NaturalSearchRequest}
 */
export interface SearchNaturalSearchRequest {
  /**
   * Filters to enforce on top of the query, in the same shape the response reports them under `filters.applied` — so a filter from a previous response can be edited and sent straight back. Each is applied as given and wins over whatever the query text would have implied for the same field; omitting one is how you drop it. A filter on an unknown or reserved field is not enforced and comes back under `filters.rejected`, never under `filters.applied`.
   *
   * Every filter you send is enforced whatever its `role`, so echoing back all of `filters.applied` searches more narrowly than the original search: send only the filters you mean to pin. To reproduce a search, send its block as `replay` instead.
   */
  filters?: SearchResponseFilterInput[];
  /**
   * Optional reference image for visual search. **Not supported yet**: a request carrying one is rejected with a 400 until a visual-similarity backend serves it.
   */
  image?: SearchNaturalSearchImage | null;
  /**
   * **Deprecated** alias of `per_page`. When both are given, `per_page` wins.
   */
  limit?: number;
  /**
   * Cap on how many finer-grain sub-items (e.g. localized segments) each nested result keeps, trimming the low-signal tail to the top-N most relevant. `null` keeps every matched sub-item. Only affects nested results; never changes which items surface or their ranking.
   */
  max_sub_items?: number | null;
  /**
   * Return items with sub-items instead of a flat list.
   */
  nested_results?: boolean;
  /**
   * 1-based page to return. Above 1, requires `replay` (the `filters` of the response being continued), or the request is rejected with a 400. Ignored when `search_after` is given.
   */
  page?: number;
  /**
   * Number of results per page; replaces `limit`. Exact on a paginated answer (`pagination.supported` true); an unpaginated answer may return more ranked results than this.
   */
  per_page?: number | null;
  /**
   * Free-text natural-language query.
   */
  query?: string | null;
  /**
   * A response's `filters` block (or an `interpretations[].filters` one), sent back as received, possibly with entries removed from `applied`. The search then runs that interpretation instead of reading the query again: no language-model call, one retrieval round, no zero-result recovery. Use it to page through an answer, run another reading, or re-run it with a filter dropped. An entry this server cannot honour is a 400. Cannot be combined with `filters`.
   */
  replay?: SearchNaturalSearchReplay | null;
  /**
   * Grain the result list should be expressed in (e.g. `asset`, `segment`). Omit to let the search decide. When coarser than the interesting grain (e.g. `asset` while ranking on the best `segment`s), each item carries its matched finer hits as sub-items and `limit` counts the coarser items.
   */
  result_unit?: ('asset' | 'segment' | 'collection' | 'post') | null;
  /**
   * Infinite-scroll pagination key, as on `/v2/search/`: the `_sort` of the last object of the previous response. Wins over `page`. Requires `replay` (the previous response's `filters`), or the request is rejected with a 400.
   */
  search_after?: unknown[] | null;
}
/**
 * Original schema `NaturalSearchResponse`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-NaturalSearchResponse}
 */
export interface SearchNaturalSearchResponse {
  /**
   * The documents `objects` refer to but do not contain, keyed by asset id. Empty unless the results are moments. Plain documents: the ranking story (`score`, `evidence`, `match`) belongs to the moment that matched, not to the asset it happens to sit in.
   */
  assets?: {
    [k: string]: SearchSearchDocument;
  };
  /**
   * True when at least one search backend failed, timed out or answered partially. The results are still usable, just not the full picture.
   */
  degraded?: boolean;
  /**
   * Always null here; natural search computes no aggregations.
   */
  facets?: {
    [k: string]: unknown;
  } | null;
  filters?: SearchResponseFilters;
  first_url?: string | null;
  /**
   * Every way the query was read, best first; more than one when the query is ambiguous (e.g. a name to filter on, or a word in the content). The search stops at the first reading that finds something; `answered` marks it.
   *
   * Show another entry's `why` as a "did you mean ...?" and, if picked, re-post with that entry's `filters` as `replay`. Each is shaped like this response's `filters`; the `answered` entry carries it unchanged.
   */
  interpretations?: SearchResponseInterpretation[];
  /**
   * BCP-47 tag of the query's language, which the `interpretations` sentences are written in. Empty when unknown.
   */
  language?: string;
  last_url?: string | null;
  /**
   * The best `match.quality` among `objects` — what the search can claim about this answer as a whole. Null when there are no results. `related` means stand-in words matched a question about what a result shows. Below that, the query as typed matched nothing and these are recovered results: worth showing and labelling, not presenting as the answer.
   */
  match_quality?: ('exact' | 'related' | 'approximate' | 'filters_only') | null;
  next_url?: string | null;
  /**
   * The ranked results, at the requested `result_unit`. Documents for an asset/collection grain; moments (see `NaturalSearchMoment`) when `result_unit` is `segment`.
   */
  objects?: (SearchNaturalSearchDocument | SearchNaturalSearchMoment)[];
  page?: number | null;
  pages?: number | null;
  pagination?: SearchResponsePagination;
  per_page?: number | null;
  prev_url?: string | null;
  scroll_id?: string | null;
  total?: number | null;
}
/**
 * Original schema `SearchDocument`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchDocument}
 */
export interface SearchSearchDocument {
  date_created?: string | null;
  date_modified?: string | null;
  description?: string | null;
  id?: string | null;
  metadata?: {
    [k: string]: unknown;
  } | null;
  object_type: string;
  title: string;
}
/**
 * The whole query behind these results. Send it back as the request's `replay` (as received, or with entries removed from `applied`) to continue or re-run this search.
 *
 * `applied` built the query that produced these results; each entry either excluded results (`role: filter`) or only ranked them (`role: scoring`). The words and meaning searched are ordinary entries on the fields they ran against. `relaxed` holds restrictions an earlier attempt enforced and this answer does not; re-sending one will probably empty the search. `rejected` could not be honoured; re-sending one changes nothing.
 *
 * These are not a partition: a field can be in `applied` as a scoring signal and in `relaxed` as an abandoned restriction ("nothing matched X, here is what we widened to").
 *
 * `exact_text` / `meaning_led` say how the answering query matched; a replay reads them back so a later page grades its hits the same.
 */
export interface SearchResponseFilters {
  applied?: SearchResponseFilterOutput[];
  exact_text?: boolean;
  meaning_led?: boolean;
  modalities?: SearchModality[];
  order?: SearchResultOrder | null;
  query?: string | null;
  ranking_unit?: SearchRankingUnit | null;
  rejected?: SearchResponseFilterOutput[];
  relaxed?: SearchResponseFilterOutput[];
  result_unit?: SearchRankingUnit | null;
  scoring?: SearchResponseScoring;
  sources?: SearchResponseSource[];
  version?: number;
}
/**
 * Original schema `ResponseFilter-Output`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-ResponseFilter-Output}
 */
export interface SearchResponseFilterOutput {
  facetable?: boolean;
  field: string;
  field_type?: string;
  label?: string | null;
  predicate:
    | SearchKeywordPredicate
    | SearchPublicLexicalPredicateOutput
    | SearchPublicSemanticPredicateOutput;
  pushed_down?: boolean;
  reason?: string | null;
  role?: SearchFilterRole | null;
  value_labels?: {
    [k: string]: string;
  };
  weight?: number;
}
/**
 * Original schema `PublicLexicalPredicate-Output`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-PublicLexicalPredicate-Output}
 */
export interface SearchPublicLexicalPredicateOutput {
  any_of?: string[];
  fuzziness?: string | null;
  kind?: 'lexical';
  operator?: ('and' | 'or') | null;
  sub_field?: string | null;
  terms?: string;
}
/**
 * Original schema `PublicSemanticPredicate-Output`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-PublicSemanticPredicate-Output}
 */
export interface SearchPublicSemanticPredicateOutput {
  kind?: 'semantic';
  text: string;
}
/**
 * Original schema `ResponseScoring`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-ResponseScoring}
 */
export interface SearchResponseScoring {
  methods?: SearchScoringMethod[];
}
/**
 * Original schema `ScoringMethod`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-ScoringMethod}
 */
export interface SearchScoringMethod {
  method: string;
  model?: string | null;
  params?: {
    [k: string]: string;
  };
  stage: SearchScoringStage;
}
/**
 * Original schema `ResponseSource`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-ResponseSource}
 */
export interface SearchResponseSource {
  display_name: string;
  ref: string;
  state: SearchSourceState;
}
/**
 * Original schema `ResponseInterpretation`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-ResponseInterpretation}
 */
export interface SearchResponseInterpretation {
  answered?: boolean;
  confidence?: number;
  filters?: SearchResponseFilters1;
  why?: string;
}
/**
 * Original schema `ResponseFilters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-ResponseFilters}
 */
export interface SearchResponseFilters1 {
  applied?: SearchResponseFilterOutput[];
  exact_text?: boolean;
  meaning_led?: boolean;
  modalities?: SearchModality[];
  order?: SearchResultOrder | null;
  query?: string | null;
  ranking_unit?: SearchRankingUnit | null;
  rejected?: SearchResponseFilterOutput[];
  relaxed?: SearchResponseFilterOutput[];
  result_unit?: SearchRankingUnit | null;
  scoring?: SearchResponseScoring;
  sources?: SearchResponseSource[];
  version?: number;
}
/**
 * Whether this answer can be walked page by page (`supported`, known from the first response), and where in it you are. To fetch the next page, re-post the same body with this response's `filters` as `replay`, and either `page + 1` or the last object's `_sort` as `search_after`.
 */
export interface SearchResponsePagination {
  page?: number;
  pages?: number;
  per_page?: number;
  reason?: SearchPaginationRefusal | null;
  supported?: boolean;
  total?: number | null;
}
/**
 * Original schema `NltfContext`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-NltfContext}
 */
export interface SearchNltfContext {
  displayed_filters?: SearchNltfDisplayedFilters | null;
}
/**
 * Original schema `NltfDisplayedFilters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-NltfDisplayedFilters}
 */
export interface SearchNltfDisplayedFilters {
  facets?: {
    [k: string]: unknown;
  } | null;
  filters?: {
    [k: string]: unknown;
  } | null;
}
/**
 * Original schema `NltfContextSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-NltfContextSchema}
 */
export interface SearchNltfContextSchema {
  displayed_filters?: SearchNltfDisplayedFilters;
}
/**
 * Original schema `NltfDisplayedFiltersSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-NltfDisplayedFiltersSchema}
 */
export interface SearchNltfDisplayedFiltersSchema {
  facets?: {
    [k: string]: (string | number)[];
  };
  filters?: {
    [k: string]: (string | number)[];
  };
}
/**
 * Original schema `NltfParseMetadata`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-NltfParseMetadata}
 */
export interface SearchNltfParseMetadata {
  model?: string | null;
  original_query?: string | null;
  provider?: string | null;
  source_trace_id?: string | null;
}
/**
 * Original schema `NltfParseMetadataSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-NltfParseMetadataSchema}
 */
export interface SearchNltfParseMetadataSchema {
  model?: string;
  original_query?: string;
  provider?: string;
}
/**
 * Original schema `NltfParseRequest`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-NltfParseRequest}
 */
export interface SearchNltfParseRequest {
  context?: SearchNltfContext | null;
  query: string;
}
/**
 * Original schema `NltfParseRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-NltfParseRequestSchema}
 */
export interface SearchNltfParseRequestSchema {
  context?: SearchNltfContextSchema;
  query: string;
}
/**
 * Original schema `NltfParseResponse`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-NltfParseResponse}
 */
export interface SearchNltfParseResponse {
  metadata?: SearchNltfParseMetadata | null;
  result?: SearchNltfParseResult | null;
}
/**
 * Original schema `NltfParseResult`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-NltfParseResult}
 */
export interface SearchNltfParseResult {
  facets_filters?: {
    [k: string]: string[];
  } | null;
  field_types?: {
    [k: string]: string;
  } | null;
  filter?: {
    [k: string]:
      | string
      | string[]
      | SearchMultiSelectFilterGroup[]
      | SearchCriteriaRangeFilter;
  } | null;
  filter_options?: {
    [k: string]: (string | number)[];
  } | null;
  query?: string | null;
  query_mapping?: {
    [k: string]: string;
  } | null;
}
/**
 * Original schema `NltfParseResponseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-NltfParseResponseSchema}
 */
export interface SearchNltfParseResponseSchema {
  metadata?: SearchNltfParseMetadataSchema;
  result?: SearchNltfParseResult;
}
/**
 * Original schema `NltfParseResultSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-NltfParseResultSchema}
 */
export interface SearchNltfParseResultSchema {
  facets_filters?: {
    [k: string]: string[];
  };
  field_types?: {
    [k: string]: string;
  };
  filter?: {
    [k: string]:
      | string
      | string[]
      | SearchMultiSelectFilterGroupSchema[]
      | SearchCriteriaRangeFilterSchema;
  };
  filter_options?: {
    [k: string]: (string | number)[];
  };
  query?: string;
  query_mapping?: {
    [k: string]: string;
  };
}
/**
 * Original schema `PingResponse`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-PingResponse}
 */
export interface SearchPingResponse {
  service?: string;
  status?: string;
  version?: string;
}
/**
 * Original schema `ReindexSavedSearchGroupSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-ReindexSavedSearchGroupSchema}
 */
export interface SearchReindexSavedSearchGroupSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexSavedSearchSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-ReindexSavedSearchSchema}
 */
export interface SearchReindexSavedSearchSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ResponsePagination`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-ResponsePagination}
 */
export interface SearchResponsePagination1 {
  page?: number;
  pages?: number;
  per_page?: number;
  reason?: SearchPaginationRefusal | null;
  supported?: boolean;
  total?: number | null;
}
/**
 * Original schema `SavedSearch`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SavedSearch}
 */
export interface SearchSavedSearch {
  criteria: SearchSearchCriteriaSaved;
  date_created?: string;
  date_modified?: string;
  favoured?: boolean;
  group_id?: string | null;
  id?: string;
  name: string;
  permissions?: string[];
}
/**
 * Original schema `SearchCriteriaSaved`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchCriteriaSaved}
 */
export interface SearchSearchCriteriaSaved {
  doc_types?: (
    | 'assets'
    | 'collections'
    | 'segments'
    | 'saved_searches'
    | 'saved_search_groups'
  )[];
  exclude_fields?: string[];
  facets?: string[];
  facets_filters?: SearchFacetFilterSchema[];
  filter?: SearchCriteriaFilterSchema;
  include_fields?: string[];
  metadata_view_id?: string;
  query?: string;
  search_fields?: string[];
  sort?: SearchCriteriaSortSchema[];
}
/**
 * Original schema `SavedSearchConvertCollectionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SavedSearchConvertCollectionSchema}
 */
export interface SearchSavedSearchConvertCollectionSchema {
  collection_id: string;
}
/**
 * Original schema `SavedSearchCopyFromTemplateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SavedSearchCopyFromTemplateSchema}
 */
export interface SearchSavedSearchCopyFromTemplateSchema {
  from_domain: string;
  metadata_view_map: {
    [k: string]: string;
  };
  to_domain: string;
}
/**
 * Original schema `SavedSearchElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SavedSearchElasticSchema}
 */
export interface SearchSavedSearchElasticSchema {
  criteria?: string;
  date_created?: string;
  date_modified?: string;
  favoured?: boolean;
  group_id?: string | null;
  id?: string;
  name: string;
  permissions?: string[];
}
/**
 * Original schema `SavedSearchGroupQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SavedSearchGroupQueryParamsSchema}
 */
export interface SearchSavedSearchGroupQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `SavedSearchGroupSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SavedSearchGroupSchema}
 */
export interface SearchSavedSearchGroupSchema {
  date_created?: string;
  date_modified?: string;
  id?: string;
  name: string;
  saved_searches_count?: number;
  system_domain_id?: string;
  user_id?: string;
}
/**
 * Original schema `SavedSearchGroupsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SavedSearchGroupsSchema}
 */
export interface SearchSavedSearchGroupsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: SearchSavedSearchGroupSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `SavedSearchQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SavedSearchQueryParamsSchema}
 */
export interface SearchSavedSearchQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  scroll?: boolean;
  scroll_id?: string;
  /**
   * This parameter is used for infinite scroll pagination instead of deprecatedscroll API. It accepts a list of sort keys that will be used for getting a next page and it can be obtained from `_sort` key of the last object of the previous response
   */
  search_after?: unknown[] | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
  /**
   * Comma-separated list of asset types to include in results. Defaults to all except POST.
   */
  types?: (
    | 'ASSET'
    | 'SEQUENCE'
    | 'NLE_PROJECT'
    | 'PLACEHOLDER'
    | 'CUSTOM'
    | 'LINK'
    | 'SUBCLIP'
    | 'POST'
  )[];
}
/**
 * Original schema `SavedSearchResultsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SavedSearchResultsSchema}
 */
export interface SearchSavedSearchResultsSchema {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  id?: string;
  last_url?: string;
  name?: string;
  next_url?: string;
  objects?: SearchSearchDocument[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  search_criteria_document?: SearchSavedSearch;
  total?: number;
}
/**
 * Original schema `SavedSearchSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SavedSearchSchema}
 */
export interface SearchSavedSearchSchema {
  criteria: SearchSearchCriteriaSaved;
  date_created?: string;
  date_modified?: string;
  favoured?: boolean;
  group_id?: string | null;
  id?: string;
  name: string;
  permissions?: string[];
}
/**
 * Original schema `SavedSearchesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SavedSearchesSchema}
 */
export interface SearchSavedSearchesSchema {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: SearchSavedSearchElasticSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `SearchBackendCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchBackendCreateSchema}
 */
export interface SearchSearchBackendCreateSchema {
  enabled?: boolean;
  kind: string;
  name?: string;
  options?: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `SearchBackendReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchBackendReadSchema}
 */
export interface SearchSearchBackendReadSchema {
  date_created?: string | null;
  date_modified?: string | null;
  enabled?: boolean;
  id: string;
  kind: string;
  name?: string;
  options?: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `SearchBackendUpdateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchBackendUpdateSchema}
 */
export interface SearchSearchBackendUpdateSchema {
  enabled?: boolean | null;
  kind?: string | null;
  name?: string | null;
  options?: {
    [k: string]: unknown;
  } | null;
}
/**
 * Original schema `SearchBackendsListSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchBackendsListSchema}
 */
export interface SearchSearchBackendsListSchema {
  objects: SearchSearchBackendReadSchema[];
}
/**
 * Original schema `SearchContentInfoInternalSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchContentInfoInternalSchema}
 */
export interface SearchSearchContentInfoInternalSchema {
  assets_count?: number;
  collections_count?: number;
  media_formats?: {
    [k: string]: unknown;
  }[];
  media_types?: {
    [k: string]: unknown;
  }[];
  storage_info?: SearchStorageContentInfo[];
  title?: string;
  total_duration_milliseconds?: number;
  total_size?: number;
}
/**
 * Original schema `StorageContentInfo`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-StorageContentInfo}
 */
export interface SearchStorageContentInfo {
  assets_count?: number;
  file_count?: number;
  storage_id?: string;
  total_duration_milliseconds?: number;
  total_size?: number;
}
/**
 * Original schema `SearchContentInfoSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchContentInfoSchema}
 */
export interface SearchSearchContentInfoSchema {
  assets_count?: number;
  collections_count?: number;
  storage_info?: SearchStorageContentInfo[];
  title?: string;
  total_duration_milliseconds?: number;
  total_size?: number;
}
/**
 * Original schema `SearchConvertCollectionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchConvertCollectionSchema}
 */
export interface SearchSearchConvertCollectionSchema {
  collection_id: string;
  doc_types?: (
    | 'assets'
    | 'collections'
    | 'segments'
    | 'saved_searches'
    | 'saved_search_groups'
  )[];
  exclude_fields?: string[];
  facets?: string[];
  facets_filters?: SearchFacetFilterSchema[];
  filter?: SearchCriteriaFilterSchema;
  include_fields?: string[];
  metadata_view_id?: string;
  query?: string;
  search_fields?: string[];
  sort?: SearchCriteriaSortSchema[];
}
/**
 * Original schema `SearchCriteria`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchCriteria}
 */
export interface SearchSearchCriteria {
  doc_types?: string[] | null;
  exclude_fields?: string[] | null;
  facets?: string[] | null;
  facets_filters?: SearchFacetFilter[] | null;
  filter?: SearchSearchCriteriaFilter | null;
  include_fields?: string[] | null;
  metadata_view_id?: string | null;
  query?: string | null;
  /**
   * Infinite-scroll pagination key (replaces the deprecated scroll API). A list of sort keys taken from the `_sort` of the last object of the previous response.
   */
  search_after?: unknown[] | null;
  search_fields?: string[] | null;
  sort?: SearchSortField[] | null;
}
/**
 * Original schema `SearchCriteriaFilter`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchCriteriaFilter}
 */
export interface SearchSearchCriteriaFilter {
  filters?: SearchSearchCriteriaFilter[] | null;
  operator: 'AND' | 'OR' | 'NOT' | 'NESTED';
  /**
   * Nested field path. Required for the `NESTED` operator.
   */
  path?: string | null;
  terms?: SearchSearchTerm[] | null;
}
/**
 * Original schema `SearchTerm`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchTerm}
 */
export interface SearchSearchTerm {
  exists?: boolean | null;
  missing?: boolean | null;
  name: string;
  range?: SearchSearchRangeFilter | null;
  value?: string | null;
  value_in?: string[] | null;
}
/**
 * Original schema `SearchRangeFilter`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchRangeFilter}
 */
export interface SearchSearchRangeFilter {
  max?: string | null;
  min?: string | null;
  /**
   * Format: +02:00. Results returned in UTC by default
   */
  timezone?: string | null;
}
/**
 * Original schema `SortField`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SortField}
 */
export interface SearchSortField {
  name: string;
  order?: string | null;
}
/**
 * Original schema `SearchCriteriaBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchCriteriaBaseSchema}
 */
export interface SearchSearchCriteriaBaseSchema {
  doc_types?: (
    | 'assets'
    | 'collections'
    | 'segments'
    | 'saved_searches'
    | 'saved_search_groups'
  )[];
  exclude_fields?: string[];
  facets?: string[];
  facets_filters?: SearchFacetFilterSchema[];
  filter?: SearchCriteriaFilterSchema;
  include_fields?: string[];
  metadata_view_id?: string;
  query?: string;
  search_fields?: string[];
  sort?: SearchCriteriaSortSchema[];
}
/**
 * Original schema `SearchCriteriaSavedSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchCriteriaSavedSchema}
 */
export interface SearchSearchCriteriaSavedSchema {
  doc_types?: (
    | 'assets'
    | 'collections'
    | 'segments'
    | 'saved_searches'
    | 'saved_search_groups'
  )[];
  exclude_fields?: string[];
  facets?: string[];
  facets_filters?: SearchFacetFilterSchema[];
  filter?: SearchCriteriaFilterSchema;
  include_fields?: string[];
  metadata_view_id?: string;
  query?: string;
  search_fields?: string[];
  sort?: SearchCriteriaSortSchema[];
}
/**
 * Original schema `SearchCriteriaSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchCriteriaSchema}
 */
export interface SearchSearchCriteriaSchema {
  doc_types?: (
    | 'assets'
    | 'collections'
    | 'segments'
    | 'saved_searches'
    | 'saved_search_groups'
  )[];
  exclude_fields?: string[];
  facets?: string[];
  facets_filters?: SearchFacetFilterSchema[];
  filter?: SearchCriteriaFilterSchema;
  include_fields?: string[];
  metadata_view_id?: string;
  query?: string;
  /**
   * This parameter is used for infinite scroll pagination instead of deprecatedscroll API. It accepts a list of sort keys that will be used for getting a next page and it can be obtained from `_sort` key of the last object of the previous response
   */
  search_after?: unknown[];
  search_fields?: string[];
  sort?: SearchCriteriaSortSchema[];
}
/**
 * Original schema `SearchDocumentInputSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchDocumentInputSchema}
 */
export interface SearchSearchDocumentInputSchema {
  fields: {
    [k: string]: unknown;
  }[];
}
/**
 * Original schema `SearchDocumentSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchDocumentSchema}
 */
export interface SearchSearchDocumentSchema {
  date_created?: string;
  date_modified?: string;
  description?: string;
  id?: string;
  metadata?: {
    [k: string]: unknown;
  };
  object_type: string;
  title: string;
}
/**
 * Original schema `SearchDocumentsResponse`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchDocumentsResponse}
 */
export interface SearchSearchDocumentsResponse {
  facets?: {
    [k: string]: unknown;
  } | null;
  first_url?: string | null;
  last_url?: string | null;
  next_url?: string | null;
  objects?: SearchSearchDocument[];
  page?: number | null;
  pages?: number | null;
  per_page?: number | null;
  prev_url?: string | null;
  scroll_id?: string | null;
  search_criteria_document?: {
    [k: string]: unknown;
  } | null;
  total?: number | null;
}
/**
 * Original schema `SearchDocumentsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchDocumentsSchema}
 */
export interface SearchSearchDocumentsSchema {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: (AssetsAssetElasticSchema | AssetsCollectionElasticSchema)[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `SearchHistory`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchHistory}
 */
export interface SearchSearchHistory {
  criteria: {
    [k: string]: unknown;
  };
  date_created?: string;
  id: string;
}
/**
 * Original schema `SearchHistoryListSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchHistoryListSchema}
 */
export interface SearchSearchHistoryListSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: SearchSearchHistory[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `SearchHistorySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchHistorySchema}
 */
export interface SearchSearchHistorySchema {
  criteria: {
    [k: string]: unknown;
  };
  date_created?: string;
  id: string;
}
/**
 * Original schema `SearchQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchQueryParamsSchema}
 */
export interface SearchSearchQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  scroll?: boolean;
  scroll_id?: string;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
  /**
   * Comma-separated list of asset types to include in results. Defaults to all except POST.
   */
  types?: (
    | 'ASSET'
    | 'SEQUENCE'
    | 'NLE_PROJECT'
    | 'PLACEHOLDER'
    | 'CUSTOM'
    | 'LINK'
    | 'SUBCLIP'
    | 'POST'
  )[];
}
/**
 * Original schema `SearchSuggestRequest`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchSuggestRequest}
 */
export interface SearchSearchSuggestRequest {
  doc_types?: string[] | null;
  field_name: string;
  metadata_view_id?: string | null;
  query: string;
}
/**
 * Original schema `SearchSuggestResponseItem`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchSuggestResponseItem}
 */
export interface SearchSearchSuggestResponseItem {
  value?: string | null;
}
/**
 * Original schema `SearchSuggestResponseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchSuggestResponseSchema}
 */
export interface SearchSearchSuggestResponseSchema {
  value?: string;
}
/**
 * Original schema `SearchSuggestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchSuggestSchema}
 */
export interface SearchSearchSuggestSchema {
  doc_types?: (
    | 'assets'
    | 'collections'
    | 'segments'
    | 'saved_searches'
    | 'saved_search_groups'
  )[];
  field_name: string;
  metadata_view_id?: string;
  query: string;
}
/**
 * Original schema `SearchSuggestsResponse`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchSuggestsResponse}
 */
export interface SearchSearchSuggestsResponse {
  objects?: SearchSearchSuggestResponseItem[];
}
/**
 * Original schema `SearchSuggestsResponseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchSuggestsResponseSchema}
 */
export interface SearchSearchSuggestsResponseSchema {
  objects?: SearchSearchSuggestResponseSchema[];
}
/**
 * Original schema `SearchViewFieldTypeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchViewFieldTypeSchema}
 */
export interface SearchSearchViewFieldTypeSchema {
  facetable?: boolean;
  label?: string;
  name?: string;
  origin_field_name?: string;
  sortable?: boolean;
  type?: string;
  width?: SearchSearchViewFieldTypeWidth;
}
/**
 * Original schema `SearchViewFieldTypeWidth`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchViewFieldTypeWidth}
 */
export interface SearchSearchViewFieldTypeWidth {
  auto_resize?: boolean;
  current?: number;
  fixed?: number;
  max?: number;
  min?: number;
}
/**
 * Original schema `SearchViewFieldTypeWidthSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchViewFieldTypeWidthSchema}
 */
export interface SearchSearchViewFieldTypeWidthSchema {
  auto_resize?: boolean;
  current?: number;
  fixed?: number;
  max?: number;
  min?: number;
}
/**
 * Original schema `SearchViewSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchViewSchema}
 */
export interface SearchSearchViewSchema {
  auto_resize_title_column?: boolean;
  date_created?: string;
  date_modified?: string;
  description?: string;
  id?: string;
  name?: string;
  view_fields?: SearchSearchViewFieldTypeSchema[];
}
/**
 * Original schema `SearchViewsIDSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchViewsIDSchema}
 */
export interface SearchSearchViewsIDSchema {
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
}
/**
 * Original schema `SearchViewsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchViewsSchema}
 */
export interface SearchSearchViewsSchema {
  objects?: SearchSearchViewSchema[];
}
/**
 * Original schema `StorageContentInfoSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-StorageContentInfoSchema}
 */
export interface SearchStorageContentInfoSchema {
  assets_count?: number;
  file_count?: number;
  storage_id?: string;
  total_duration_milliseconds?: number;
  total_size?: number;
}
/**
 * Original schema `DiscoveryEntitiesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-DiscoveryEntitiesSchema}
 */
export interface SearchDiscoveryEntitiesSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: SearchDiscoveryEntityWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `DiscoveryEntity`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-DiscoveryEntity}
 */
export interface SearchDiscoveryEntityWithIdNullable {
  date_created?: string | null;
  date_modified?: string | null;
  id: string;
  metadata?: {
    [k: string]: unknown;
  } | null;
  object_id: string;
  object_type: 'COLLECTION' | 'SAVED_SEARCH';
  title: string;
  user_id: string;
}
/**
 * Original schema `DiscoveryEntity`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-DiscoveryEntity}
 */
export interface SearchDiscoveryEntityWithId {
  date_created?: string;
  date_modified?: string;
  id: string;
  metadata?: {
    [k: string]: unknown;
  };
  object_id: string;
  object_type: 'COLLECTION' | 'SAVED_SEARCH';
  title: string;
  user_id: string;
}
/**
 * Original schema `DiscoveryEntitySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-DiscoveryEntitySchema}
 */
export interface SearchDiscoveryEntitySchemaWithId {
  date_created?: string;
  date_modified?: string;
  id: string;
  metadata?: {
    [k: string]: unknown;
  };
  object_id: string;
  object_type: 'COLLECTION' | 'SAVED_SEARCH';
  title: string;
  user_id: string;
}
/**
 * Original schema `DiscoveryEntitySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-DiscoveryEntitySchema}
 */
export interface SearchDiscoveryEntitySchemaWithIdNullable {
  date_created?: string | null;
  date_modified?: string | null;
  id: string;
  metadata?: {
    [k: string]: unknown;
  } | null;
  object_id: string;
  object_type: 'COLLECTION' | 'SAVED_SEARCH';
  title: string;
  user_id: string;
}
/**
 * Original schema `SearchDocumentsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchDocumentsSchema}
 */
export interface SearchSearchDocumentsSchemaWithId {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: (
    | AssetsAssetElasticSchemaWithIdNullable
    | AssetsCollectionElasticSchemaWithIdNullable
  )[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `SearchDocumentSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchDocumentSchema}
 */
export interface SearchSearchDocumentSchemaWithId {
  date_created?: string;
  date_modified?: string;
  description?: string;
  id: string;
  metadata?: {
    [k: string]: unknown;
  };
  object_type: string;
  title: string;
}
/**
 * Original schema `SearchDocumentSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchDocumentSchema}
 */
export interface SearchSearchDocumentSchemaWithIdNullable {
  date_created?: string | null;
  date_modified?: string | null;
  description?: string | null;
  id: string;
  metadata?: {
    [k: string]: unknown;
  } | null;
  object_type: string;
  title: string;
}
/**
 * Original schema `SearchHistoryListSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchHistoryListSchema}
 */
export interface SearchSearchHistoryListSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: SearchSearchHistoryNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `SearchHistory`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchHistory}
 */
export interface SearchSearchHistoryNullable {
  criteria: {
    [k: string]: unknown;
  };
  date_created?: string | null;
  id: string;
}
/**
 * Original schema `SavedSearchesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SavedSearchesSchema}
 */
export interface SearchSavedSearchesSchemaWithId {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: SearchSavedSearchElasticSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `SavedSearchElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SavedSearchElasticSchema}
 */
export interface SearchSavedSearchElasticSchemaWithIdNullable {
  criteria?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  favoured?: boolean | null;
  group_id?: string | null;
  id: string;
  name: string;
  permissions?: string[] | null;
}
/**
 * Original schema `SavedSearchElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SavedSearchElasticSchema}
 */
export interface SearchSavedSearchElasticSchemaWithId {
  criteria?: string;
  date_created?: string;
  date_modified?: string;
  favoured?: boolean;
  group_id?: string | null;
  id: string;
  name: string;
  permissions?: string[];
}
/**
 * Original schema `SavedSearchSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SavedSearchSchema}
 */
export interface SearchSavedSearchSchemaWithId {
  criteria: SearchSearchCriteriaSaved;
  date_created?: string;
  date_modified?: string;
  favoured?: boolean;
  group_id?: string | null;
  id: string;
  name: string;
  permissions?: string[];
}
/**
 * Original schema `SavedSearchGroupSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SavedSearchGroupSchema}
 */
export interface SearchSavedSearchGroupSchemaWithId {
  date_created?: string;
  date_modified?: string;
  id: string;
  name: string;
  saved_searches_count?: number;
  system_domain_id?: string;
  user_id?: string;
}
/**
 * Original schema `SavedSearchGroupSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SavedSearchGroupSchema}
 */
export interface SearchSavedSearchGroupSchemaWithIdNullable {
  date_created?: string | null;
  date_modified?: string | null;
  id: string;
  name: string;
  saved_searches_count?: number | null;
  system_domain_id?: string | null;
  user_id?: string | null;
}
/**
 * Original schema `SavedSearchGroupsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SavedSearchGroupsSchema}
 */
export interface SearchSavedSearchGroupsSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: SearchSavedSearchGroupSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `SavedSearchResultsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SavedSearchResultsSchema}
 */
export interface SearchSavedSearchResultsSchemaWithId {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  id: string;
  last_url?: string;
  name?: string;
  next_url?: string;
  objects: SearchSearchDocumentWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  search_criteria_document?: SearchSavedSearch;
  total: number;
}
/**
 * Original schema `SearchDocument`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchDocument}
 */
export interface SearchSearchDocumentWithIdNullable {
  date_created?: string | null;
  date_modified?: string | null;
  description?: string | null;
  id: string | null;
  metadata?: {
    [k: string]: unknown;
  } | null;
  object_type: string;
  title: string;
}
/**
 * Original schema `SearchDocument`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchDocument}
 */
export interface SearchSearchDocumentWithId {
  date_created?: string | null;
  date_modified?: string | null;
  description?: string | null;
  id: string | null;
  metadata?: {
    [k: string]: unknown;
  } | null;
  object_type: string;
  title: string;
}
/**
 * Original schema `SearchContentInfoSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchContentInfoSchema}
 */
export interface SearchSearchContentInfoSchemaNullable {
  assets_count?: number | null;
  collections_count?: number | null;
  storage_info?: SearchStorageContentInfo[] | null;
  title?: string | null;
  total_duration_milliseconds?: number | null;
  total_size?: number | null;
}
/**
 * Original schema `SearchSuggestsResponseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchSuggestsResponseSchema}
 */
export interface SearchSearchSuggestsResponseSchemaWithId {
  objects: SearchSearchSuggestResponseSchemaNullable[];
}
/**
 * Original schema `SearchSuggestResponseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchSuggestResponseSchema}
 */
export interface SearchSearchSuggestResponseSchemaNullable {
  value?: string | null;
}
/**
 * Original schema `SearchViewsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchViewsSchema}
 */
export interface SearchSearchViewsSchemaWithId {
  objects: SearchSearchViewSchemaWithIdNullable[];
}
/**
 * Original schema `SearchViewSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchViewSchema}
 */
export interface SearchSearchViewSchemaWithIdNullable {
  auto_resize_title_column?: boolean | null;
  date_created?: string | null;
  date_modified?: string | null;
  description?: string | null;
  id: string;
  name?: string | null;
  view_fields?: SearchSearchViewFieldTypeSchema[] | null;
}
/**
 * Original schema `SearchViewSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchViewSchema}
 */
export interface SearchSearchViewSchemaWithId {
  auto_resize_title_column?: boolean;
  date_created?: string;
  date_modified?: string;
  description?: string;
  id: string;
  name?: string;
  view_fields?: SearchSearchViewFieldTypeSchema[];
}
/**
 * Original schema `PingResponse`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-PingResponse}
 */
export interface SearchPingResponseNullable {
  service?: string | null;
  status?: string | null;
  version?: string | null;
}
/**
 * Original schema `SearchDocumentsResponse`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchDocumentsResponse}
 */
export interface SearchSearchDocumentsResponseWithId {
  facets?: {
    [k: string]: unknown;
  } | null;
  first_url?: string | null;
  last_url?: string | null;
  next_url?: string | null;
  objects: SearchSearchDocumentWithIdNullable[];
  page: number | null;
  pages: number | null;
  per_page: number | null;
  prev_url?: string | null;
  scroll_id?: string | null;
  search_criteria_document?: {
    [k: string]: unknown;
  } | null;
  total: number | null;
}
/**
 * Original schema `NaturalSearchResponse`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-NaturalSearchResponse}
 */
export interface SearchNaturalSearchResponseWithId {
  /**
   * The documents `objects` refer to but do not contain, keyed by asset id. Empty unless the results are moments. Plain documents: the ranking story (`score`, `evidence`, `match`) belongs to the moment that matched, not to the asset it happens to sit in.
   */
  assets?: {
    [k: string]: SearchSearchDocument;
  };
  /**
   * True when at least one search backend failed, timed out or answered partially. The results are still usable, just not the full picture.
   */
  degraded?: boolean;
  /**
   * Always null here; natural search computes no aggregations.
   */
  facets?: {
    [k: string]: unknown;
  } | null;
  filters?: SearchResponseFilters2;
  first_url?: string | null;
  /**
   * Every way the query was read, best first; more than one when the query is ambiguous (e.g. a name to filter on, or a word in the content). The search stops at the first reading that finds something; `answered` marks it.
   *
   * Show another entry's `why` as a "did you mean ...?" and, if picked, re-post with that entry's `filters` as `replay`. Each is shaped like this response's `filters`; the `answered` entry carries it unchanged.
   */
  interpretations?: SearchResponseInterpretation[];
  /**
   * BCP-47 tag of the query's language, which the `interpretations` sentences are written in. Empty when unknown.
   */
  language?: string;
  last_url?: string | null;
  /**
   * The best `match.quality` among `objects` — what the search can claim about this answer as a whole. Null when there are no results. `related` means stand-in words matched a question about what a result shows. Below that, the query as typed matched nothing and these are recovered results: worth showing and labelling, not presenting as the answer.
   */
  match_quality?: ('exact' | 'related' | 'approximate' | 'filters_only') | null;
  next_url?: string | null;
  /**
   * The ranked results, at the requested `result_unit`. Documents for an asset/collection grain; moments (see `NaturalSearchMoment`) when `result_unit` is `segment`.
   */
  objects: (SearchNaturalSearchDocument | SearchNaturalSearchMoment)[];
  page: number | null;
  pages: number | null;
  pagination?: SearchResponsePagination2;
  per_page: number | null;
  prev_url?: string | null;
  scroll_id?: string | null;
  total: number | null;
}
/**
 * Original schema `ResponseFilters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-ResponseFilters}
 */
export interface SearchResponseFilters2 {
  applied?: SearchResponseFilterOutput[];
  exact_text?: boolean;
  meaning_led?: boolean;
  modalities?: SearchModality[];
  order?: SearchResultOrder | null;
  query?: string | null;
  ranking_unit?: SearchRankingUnit | null;
  rejected?: SearchResponseFilterOutput[];
  relaxed?: SearchResponseFilterOutput[];
  result_unit?: SearchRankingUnit | null;
  scoring?: SearchResponseScoring;
  sources?: SearchResponseSource[];
  version?: number;
}
/**
 * Whether this answer can be walked page by page (`supported`, known from the first response), and where in it you are. To fetch the next page, re-post the same body with this response's `filters` as `replay`, and either `page + 1` or the last object's `_sort` as `search_after`.
 */
export interface SearchResponsePagination2 {
  page?: number;
  pages?: number;
  per_page?: number;
  reason?: SearchPaginationRefusal | null;
  supported?: boolean;
  total?: number | null;
}
/**
 * Original schema `SearchSuggestsResponse`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchSuggestsResponse}
 */
export interface SearchSearchSuggestsResponseWithId {
  objects: SearchSearchSuggestResponseItemNullable[];
}
/**
 * Original schema `SearchSuggestResponseItem`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchSuggestResponseItem}
 */
export interface SearchSearchSuggestResponseItemNullable {
  value?: string | null;
}
/**
 * Original schema `SearchBackendReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#model-SearchBackendReadSchema}
 */
export interface SearchSearchBackendReadSchemaNullable {
  date_created?: string | null;
  date_modified?: string | null;
  enabled?: boolean | null;
  id: string;
  kind: string;
  name?: string | null;
  options?: {
    [k: string]: unknown;
  } | null;
}

/**
 * `PUT /v1/discovery/default/`
 *
 * Update default discovery view
 *
 * Required roles:
 *  - can_write_discovery_entities
 *
 * Responses
 * - 200 - Returns updated default discovery view
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link SearchDiscoveryViewSettingsSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/put_v1_discovery_default_}
 * @deprecated
 */
export const httpPutDiscoveryDefault = (
  body: SearchDiscoveryViewSettingsSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPutDiscoveryDefault,
  method: httpMethod.put,
  url: '/API/search/v1/discovery/default/',

  body,
  headers,
});

/**
 * `GET /v1/discovery/default/entities/`
 *
 * Returns the discovery entities that are used to build the discovery view.
 *
 * Required roles:
 *  - can_read_discovery_entities
 *
 * Responses
 * - 200 - Returns the configured discovery entities
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link SearchDiscoveryEntitiesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/get_v1_discovery_default_entities_}
 * @deprecated
 */
export const httpGetDiscoveryDefaultEntities = (
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpGetDiscoveryDefaultEntities,
  method: httpMethod.get,
  url: '/API/search/v1/discovery/default/entities/',

  headers,
});

/**
 * `POST /v1/discovery/default/entities/`
 *
 * Adds a new discovery entity.
 *
 * <br/>This creates an entry for the discovery view to show collections and saved searches.<br/>Object Type should be one of COLLECTION, SAVED_SEARCH, ASSET, RECOMMENDATION or TRENDING<br/>Object ID is only needed in the case of COLLECTION, SAVED_SEARCH or ASSET<br/>metadata is for user defined extra data.<br/><br/>This creates an entry for the discovery view to show collections and saved searches.<br/>Object Type should be one of COLLECTION, SAVED_SEARCH, ASSET, RECOMMENDATION or TRENDING<br/>Object ID is only needed in the case of COLLECTION, SAVED_SEARCH or ASSET<br/>metadata is for user defined extra data.<br/>
 * Required roles:
 *  - can_write_discovery_entities
 *
 * Responses
 * - 201 - Returns the created discovery entity
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Access denied to the object of the discovery entity
 *
 * Response {@link SearchDiscoveryEntitySchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/post_v1_discovery_default_entities_}
 * @deprecated
 */
export const httpPostDiscoveryDefaultEntities = (
  body: SearchDiscoveryEntitySchema,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPostDiscoveryDefaultEntities,
  method: httpMethod.post,
  url: '/API/search/v1/discovery/default/entities/',

  body,
  headers,
});

/**
 * `GET /v1/discovery/default/entities/admin/`
 *
 * Returns the discovery entities that are used to build the discovery view.
 *
 * Required roles:
 *  - can_write_discovery_entities
 *
 * Responses
 * - 200 - Returns the configured discovery entities
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link SearchDiscoveryEntitiesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/get_v1_discovery_default_entities_admin_}
 * @deprecated
 */
export const httpGetDiscoveryDefaultEntitiesAdmin = (
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpGetDiscoveryDefaultEntitiesAdmin,
  method: httpMethod.get,
  url: '/API/search/v1/discovery/default/entities/admin/',

  headers,
});

/**
 * `DELETE /v1/discovery/default/entities/{entity_id}/`
 *
 * Delete a discovery entity by id
 *
 * Required roles:
 *  - can_delete_discovery_entities
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Access denied to the object of the discovery entity
 * - 404 - Discovery entity does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/delete_v1_discovery_default_entities__entity_id__}
 * @deprecated
 */
export const httpDeleteDiscoveryDefaultEntitiesByEntityId = (
  entityId: string,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpDeleteDiscoveryDefaultEntitiesByEntityId,
  method: httpMethod.delete,
  url: `/API/search/v1/discovery/default/entities/${encodeURIComponent(entityId)}/`,
  params: { entityId },
  headers,
});

/**
 * `GET /v1/discovery/default/entities/{entity_id}/`
 *
 * Returns discovery entity
 *
 * Required roles:
 *  - can_read_discovery_entities
 *
 * Responses
 * - 200 - Returns Discovery entity
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Access denied to the object of the discovery entity
 * - 404 - Discovery entity does not exist
 *
 * Response {@link SearchDiscoveryEntitySchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/get_v1_discovery_default_entities__entity_id__}
 * @deprecated
 */
export const httpGetDiscoveryDefaultEntitiesByEntityId = (
  entityId: string,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpGetDiscoveryDefaultEntitiesByEntityId,
  method: httpMethod.get,
  url: `/API/search/v1/discovery/default/entities/${encodeURIComponent(entityId)}/`,
  params: { entityId },
  headers,
});

export type SearchDiscoveryEntitySchemaPartial =
  Partial<SearchDiscoveryEntitySchema>;

/**
 * `PATCH /v1/discovery/default/entities/{entity_id}/`
 *
 * Update a discovery entity by id
 *
 * Required roles:
 *  - can_write_discovery_entities
 *
 * Responses
 * - 200 - Returns updated entity
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Access denied to the object of the discovery entity
 * - 404 - Discovery entity does not exist
 *
 * Response {@link SearchDiscoveryEntitySchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/patch_v1_discovery_default_entities__entity_id__}
 * @deprecated
 */
export const httpPatchDiscoveryDefaultEntitiesByEntityId = (
  entityId: string,
  body: SearchDiscoveryEntitySchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPatchDiscoveryDefaultEntitiesByEntityId,
  method: httpMethod.patch,
  url: `/API/search/v1/discovery/default/entities/${encodeURIComponent(entityId)}/`,
  params: { entityId },
  body,
  headers,
});

/**
 * `PUT /v1/discovery/default/entities/{entity_id}/`
 *
 * Update a discovery entity by id
 *
 * Required roles:
 *  - can_write_discovery_entities
 *
 * Responses
 * - 200 - Returns updated entity
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Access denied to the object of the discovery entity
 * - 404 - Discovery entity does not exist
 *
 * Response {@link SearchDiscoveryEntitySchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/put_v1_discovery_default_entities__entity_id__}
 * @deprecated
 */
export const httpPutDiscoveryDefaultEntitiesByEntityId = (
  entityId: string,
  body: SearchDiscoveryEntitySchema,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPutDiscoveryDefaultEntitiesByEntityId,
  method: httpMethod.put,
  url: `/API/search/v1/discovery/default/entities/${encodeURIComponent(entityId)}/`,
  params: { entityId },
  body,
  headers,
});

/**
 * `PATCH /v1/discovery/entities/{object_type}/{object_id}/`
 *
 * Update a discovery entity by object's type and id
 *
 * Required roles:
 *  - can_write_discovery_entities
 *
 * Responses
 * - 200 - Returns updated entity
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Access denied to the object of the discovery entity
 * - 404 - Discovery entity does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/patch_v1_discovery_entities__object_type___object_id__}
 * @deprecated
 */
export const httpPatchDiscoveryEntitiesByObjectTypeByObjectId = (
  objectType: string,
  objectId: string,
  body: SearchDiscoveryEntitySchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPatchDiscoveryEntitiesByObjectTypeByObjectId,
  method: httpMethod.patch,
  url: `/API/search/v1/discovery/entities/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/`,
  params: { objectType, objectId },
  body,
  headers,
});

/**
 * `PUT /v1/discovery/entities/{object_type}/{object_id}/`
 *
 * Update a discovery entity by object's type and id
 *
 * Required roles:
 *  - can_write_discovery_entities
 *
 * Responses
 * - 200 - Returns updated entity
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Access denied to the object of the discovery entity
 * - 404 - Discovery entity does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/put_v1_discovery_entities__object_type___object_id__}
 * @deprecated
 */
export const httpPutDiscoveryEntitiesByObjectTypeByObjectId = (
  objectType: string,
  objectId: string,
  body: SearchDiscoveryEntitySchema,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPutDiscoveryEntitiesByObjectTypeByObjectId,
  method: httpMethod.put,
  url: `/API/search/v1/discovery/entities/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/`,
  params: { objectType, objectId },
  body,
  headers,
});

export interface SearchHttpDeleteFavoritesQuery {
  /**
   * Set to true to reindex the saved searches immediately instead of in the background
   *
   */
  index_immediately?: boolean;
}

/**
 * `DELETE /v1/favorites/`
 *
 * Deletes multiple saved searches from a list of favorites
 *
 * Required roles:
 *  - can_delete_favorites
 *
 * Responses
 * - 200 - Returns a list of saved search IDs that were removed from favorites
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission check failed
 * - 404 - Saved search does not exist
 *
 * Response {@link SearchBulkDeleteFromFavoritesSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/delete_v1_favorites_}
 */
export const httpDeleteFavorites = (
  body: SearchBulkDeleteFromFavoritesSchema,
  query?: SearchHttpDeleteFavoritesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpDeleteFavorites,
  method: httpMethod.delete,
  url: '/API/search/v1/favorites/',

  body,
  query,
  headers,
});

export interface SearchHttpPostFavoritesQuery {
  /**
   * Set to true to reindex the saved searches immediately instead of in the background
   *
   */
  index_immediately?: boolean;
}

/**
 * `POST /v1/favorites/`
 *
 * Adds multiple saved searches to a list of favorites
 *
 * Required roles:
 *  - can_write_favorites
 *
 * Responses
 * - 200 - Returns a list of saved search IDs that were added to favorites
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Permission check failed
 * - 404 - Saved search does not exist
 *
 * Response {@link SearchBulkAddToFavoritesSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/post_v1_favorites_}
 */
export const httpPostFavorites = (
  body: SearchBulkAddToFavoritesSchema,
  query?: SearchHttpPostFavoritesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPostFavorites,
  method: httpMethod.post,
  url: '/API/search/v1/favorites/',

  body,
  query,
  headers,
});

/**
 * `POST /v1/nltf_parse/`
 *
 * Parse a natural language query into structured search filters
 *
 * Required roles:
 *  - can_search
 * - can_search_with_ai
 *
 * Responses
 * - 200 - Returns the parsed query result with metadata
 * - 400 - Bad request - missing or invalid query
 * - 403 - NLTF is not enabled for this domain
 * - 429 - AI service rate-limited — frontend should retry with backoff
 * - 500 - Internal server error during parsing
 * - 502 - Upstream error (LLM authentication failed or unparseable output)
 * - 503 - NLTF client not initialized or unhealthy
 *
 * Response {@link SearchNltfParseResponseSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/post_v1_nltf_parse_}
 */
export const httpPostNltfParse = (
  body: SearchNltfParseRequestSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPostNltfParse,
  method: httpMethod.post,
  url: '/API/search/v1/nltf_parse/',

  body,
  headers,
});

export interface SearchHttpPostSearchQuery {
  /**
   * The number of documents for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * If true, use scroll pagination instead of the default pagination. Deprecated, use the search_after body parameter instead.
   *
   */
  scroll?: boolean;
  /**
   * In order to get next batch of results using scroll pagination the scroll_id is required
   */
  scroll_id?: string;
  /**
   * Set to false if you don't need a URL, will speed things up
   */
  generate_signed_url?: boolean;
  /**
   * Set to true if you also want the file download URLs generated
   */
  generate_signed_download_url?: boolean;
  /**
   * Set to true if you want to generate signed proxy urls
   */
  generate_signed_proxy_url?: boolean;
  /**
   * Set to false if you don't want to save the search to the history
   */
  save_search_history?: boolean;
  /**
   * Comma-separated list of asset types to include in results. Defaults to all except POST.
   */
  types?: string;
  /**
   * Set to true to include the users who created the objects in the results
   */
  include_users?: boolean;
}

/**
 * `POST /v1/search/`
 *
 * Search
 *
 * Required roles:
 *  - can_search
 *
 * Responses
 * - 200 - Returns the result of search
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 * - 422 - The search query was rejected by Elasticsearch
 * - 504 - Connection timed out
 *
 * Response {@link SearchSearchDocumentsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/post_v1_search_}
 */
export const httpPostSearch = (
  body: SearchSearchCriteriaSchema,
  query?: SearchHttpPostSearchQuery,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPostSearch,
  method: httpMethod.post,
  url: '/API/search/v1/search/',

  body,
  query,
  headers,
});

export interface SearchHttpPostSearchContentInfoQuery {
  /**
   * Compute total size only for files with the specified format name (default - ORIGINAL)
   */
  format_name?: string;
  /**
   * Group results by storage_id / storage_method
   */
  by_storage_id?: boolean;
}

/**
 * `POST /v1/search/content/info/`
 *
 * Get aggregated information about search results
 *
 * <br/>The returned information includes count of assets and collections,<br/>total size of all assets (in bytes) and total duration of video and audio<br/>assets (in milliseconds).<br/>The returned information includes count of assets and collections,<br/>total size of all assets (in bytes) and total duration of video and audio<br/>assets (in milliseconds).
 * Required roles:
 *  - can_search
 *
 * Responses
 * - 200 - Returns aggregated information about the search results
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 422 - The search query was rejected by Elasticsearch
 *
 * Response {@link SearchSearchContentInfoSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/post_v1_search_content_info_}
 */
export const httpPostSearchContentInfo = (
  body: SearchSearchCriteriaSavedSchema,
  query?: SearchHttpPostSearchContentInfoQuery,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPostSearchContentInfo,
  method: httpMethod.post,
  url: '/API/search/v1/search/content/info/',

  body,
  query,
  headers,
});

/**
 * `POST /v1/search/convert_to_collection/`
 *
 * Copies the results of a search to a collection
 *
 * Required roles:
 *  - can_search
 * - can_create_collections
 * - can_write_collections
 *
 * Responses
 * - 202 - Schedules all the assets of the search to be added to a collection
 * - 400 - Bad request, or the search does not have any results, or it has more results than `CONVERT_SEARCH_TO_COLLECTION_MAX_HITS`
 * - 401 - Token is invalid
 * - 403 - Access denied
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/post_v1_search_convert_to_collection_}
 */
export const httpPostSearchConvertToCollection = (
  body: SearchSearchConvertCollectionSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPostSearchConvertToCollection,
  method: httpMethod.post,
  url: '/API/search/v1/search/convert_to_collection/',

  body,
  headers,
});

/**
 * `GET /v1/search/history/`
 *
 * Returns the current search history
 *
 * Required roles:
 *  - can_read_search_history
 *
 * Responses
 * - 200 - Returns list of last 25 searches
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link SearchSearchHistoryListSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/get_v1_search_history_}
 */
export const httpGetSearchHistory = (headers?: IconikApiHeaders) => ({
  id: SearchHttpGetSearchHistory,
  method: httpMethod.get,
  url: '/API/search/v1/search/history/',

  headers,
});

/**
 * `DELETE /v1/search/history/{search_history_id}/`
 *
 * Delete a search from history by its id
 *
 * Required roles:
 *  - can_delete_search_history
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Search History does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/delete_v1_search_history__search_history_id__}
 */
export const httpDeleteSearchHistoryBySearchHistoryId = (
  searchHistoryId: string,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpDeleteSearchHistoryBySearchHistoryId,
  method: httpMethod.delete,
  url: `/API/search/v1/search/history/${encodeURIComponent(searchHistoryId)}/`,
  params: { searchHistoryId },
  headers,
});

export interface SearchHttpGetSearchHistoryBySearchHistoryIdQuery {
  /**
   * The number of documents for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * Set to false if you don't need a URL, will speed things up
   */
  generate_signed_url?: boolean;
  /**
   * Set to true if you want to generate signed download urls
   */
  generate_signed_download_url?: boolean;
  /**
   * Set to true if you want to generate signed proxy urls
   */
  generate_signed_proxy_url?: boolean;
}

/**
 * `GET /v1/search/history/{search_history_id}/`
 *
 * Returns results of search history
 *
 * Required roles:
 *  - can_read_search_history
 *
 * Responses
 * - 200 - Returns results of search history
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 * - 422 - The search query was rejected by Elasticsearch
 *
 * Response {@link SearchSearchDocumentsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/get_v1_search_history__search_history_id__}
 */
export const httpGetSearchHistoryBySearchHistoryId = (
  searchHistoryId: string,
  query?: SearchHttpGetSearchHistoryBySearchHistoryIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpGetSearchHistoryBySearchHistoryId,
  method: httpMethod.get,
  url: `/API/search/v1/search/history/${encodeURIComponent(searchHistoryId)}/`,
  params: { searchHistoryId },
  query,
  headers,
});

export interface SearchHttpGetSearchSavedQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * If true passed then uses scroll pagination instead of default one
   */
  scroll?: boolean;
  /**
   * In order to get next batch of results using scroll pagination the scroll_id is required
   */
  scroll_id?: string;
  /**
   * A comma separated list of fieldnames with order. For example - name,asc;group_id,desc
   */
  sort?: string;
  /**
   * Group ID
   */
  group_id?: string;
  /**
   * Filter list of id:s (comma separated)
   */
  ids?: string;
  /**
   * Search using query
   */
  query?: string;
  /**
   * If true, only returns favorite saved searches
   */
  favorites?: boolean;
}

/**
 * `GET /v1/search/saved/`
 *
 * Returns list of saved searches
 *
 * Required roles:
 *  - can_read_saved_searches
 *
 * Responses
 * - 200 - Returns results of saved search
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Page does not exist
 *
 * Response {@link SearchSavedSearchesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/get_v1_search_saved_}
 */
export const httpGetSearchSaved = (
  query?: SearchHttpGetSearchSavedQuery,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpGetSearchSaved,
  method: httpMethod.get,
  url: '/API/search/v1/search/saved/',

  query,
  headers,
});

export interface SearchHttpPostSearchSavedQuery {
  /**
   * Set to true to index the saved search immediately instead of in the background
   *
   */
  index_immediately?: boolean;
}

/**
 * `POST /v1/search/saved/`
 *
 * Search, save and return result of this search
 *
 * Required roles:
 *  - can_write_saved_searches
 *
 * Responses
 * - 201 - Returns the created saved search
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link SearchSavedSearchSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/post_v1_search_saved_}
 */
export const httpPostSearchSaved = (
  body: SearchSavedSearchSchema,
  query?: SearchHttpPostSearchSavedQuery,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPostSearchSaved,
  method: httpMethod.post,
  url: '/API/search/v1/search/saved/',

  body,
  query,
  headers,
});

export interface SearchHttpPostSearchSavedGroupQuery {
  /**
   * Set to true to index the saved search group immediately instead of in the background
   *
   */
  index_immediately?: boolean;
}

/**
 * `POST /v1/search/saved/group/`
 *
 * Create and return saved search group data
 *
 * Required roles:
 *  - can_write_saved_search_groups
 *
 * Responses
 * - 201 - Returns the result of creation of search group instance
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link SearchSavedSearchGroupSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/post_v1_search_saved_group_}
 */
export const httpPostSearchSavedGroup = (
  body: SearchSavedSearchGroupSchema,
  query?: SearchHttpPostSearchSavedGroupQuery,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPostSearchSavedGroup,
  method: httpMethod.post,
  url: '/API/search/v1/search/saved/group/',

  body,
  query,
  headers,
});

/**
 * `DELETE /v1/search/saved/group/{group_id}/`
 *
 * Delete a saved search group by its id
 *
 * Required roles:
 *  - can_delete_saved_search_groups
 *
 * Responses
 * - 204 - Without body
 * - 401 - Token is invalid
 * - 403 - Permission to some searches is denied
 * - 404 - Saved search group does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/delete_v1_search_saved_group__group_id__}
 */
export const httpDeleteSearchSavedGroupByGroupId = (
  groupId: string,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpDeleteSearchSavedGroupByGroupId,
  method: httpMethod.delete,
  url: `/API/search/v1/search/saved/group/${encodeURIComponent(groupId)}/`,
  params: { groupId },
  headers,
});

/**
 * `GET /v1/search/saved/group/{group_id}/`
 *
 * Returns saved search group data
 *
 * Required roles:
 *  - can_read_saved_searches
 *
 * Responses
 * - 200 - Returns saved search group info
 * - 401 - Token is invalid
 * - 404 - Saved search group does not exist
 *
 * Response {@link SearchSavedSearchGroupSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/get_v1_search_saved_group__group_id__}
 */
export const httpGetSearchSavedGroupByGroupId = (
  groupId: string,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpGetSearchSavedGroupByGroupId,
  method: httpMethod.get,
  url: `/API/search/v1/search/saved/group/${encodeURIComponent(groupId)}/`,
  params: { groupId },
  headers,
});

export type SearchSavedSearchGroupSchemaPartial =
  Partial<SearchSavedSearchGroupSchema>;

/**
 * `PATCH /v1/search/saved/group/{group_id}/`
 *
 * Update and return saved search group data
 *
 * Required roles:
 *  - can_write_saved_search_groups
 *
 * Responses
 * - 200 - Returns the result of updating group
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Saved search group does not exist
 *
 * Response {@link SearchSavedSearchGroupSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/patch_v1_search_saved_group__group_id__}
 */
export const httpPatchSearchSavedGroupByGroupId = (
  groupId: string,
  body: SearchSavedSearchGroupSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPatchSearchSavedGroupByGroupId,
  method: httpMethod.patch,
  url: `/API/search/v1/search/saved/group/${encodeURIComponent(groupId)}/`,
  params: { groupId },
  body,
  headers,
});

/**
 * `PUT /v1/search/saved/group/{group_id}/`
 *
 * Update and return saved search group data
 *
 * Required roles:
 *  - can_write_saved_search_groups
 *
 * Responses
 * - 200 - Returns the result of updating group
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Saved search group does not exist
 *
 * Response {@link SearchSavedSearchGroupSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/put_v1_search_saved_group__group_id__}
 */
export const httpPutSearchSavedGroupByGroupId = (
  groupId: string,
  body: SearchSavedSearchGroupSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPutSearchSavedGroupByGroupId,
  method: httpMethod.put,
  url: `/API/search/v1/search/saved/group/${encodeURIComponent(groupId)}/`,
  params: { groupId },
  body,
  headers,
});

/**
 * `DELETE /v1/search/saved/group/{group_id}/search/{search_id}/`
 *
 * Delete saved search from search group
 *
 * Required roles:
 *  - can_write_saved_searches
 *
 * Responses
 * - 200 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Saved search does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/delete_v1_search_saved_group__group_id__search__search_id__}
 */
export const httpDeleteSearchSavedGroupByGroupIdSearchBySearchId = (
  groupId: string,
  searchId: string,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpDeleteSearchSavedGroupByGroupIdSearchBySearchId,
  method: httpMethod.delete,
  url: `/API/search/v1/search/saved/group/${encodeURIComponent(groupId)}/search/${encodeURIComponent(searchId)}/`,
  params: { groupId, searchId },
  headers,
});

export interface SearchHttpPostSearchSavedGroupByGroupIdSearchBySearchIdQuery {
  /**
   * Set to true to index the saved search immediately instead of in the background
   *
   */
  index_immediately?: boolean;
}

/**
 * `POST /v1/search/saved/group/{group_id}/search/{search_id}/`
 *
 * Adds saved search to group
 *
 * Required roles:
 *  - can_write_saved_searches
 *
 * Responses
 * - 200 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Saved search does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/post_v1_search_saved_group__group_id__search__search_id__}
 */
export const httpPostSearchSavedGroupByGroupIdSearchBySearchId = (
  groupId: string,
  searchId: string,
  query?: SearchHttpPostSearchSavedGroupByGroupIdSearchBySearchIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPostSearchSavedGroupByGroupIdSearchBySearchId,
  method: httpMethod.post,
  url: `/API/search/v1/search/saved/group/${encodeURIComponent(groupId)}/search/${encodeURIComponent(searchId)}/`,
  params: { groupId, searchId },
  query,
  headers,
});

export interface SearchHttpGetSearchSavedGroupsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * A comma separated list of IDs. for example - 3c2db7d8-1f39-46e3-8c77-992101e5e616,683a2c63-63a0-42b0-aed8-5b62dedba840
   */
  ids?: string;
  /**
   * A comma separated list of fieldnames with order. For example - first_name,asc;last_name,desc
   */
  sort?: string;
  /**
   * Search using query
   */
  query?: string;
}

/**
 * `GET /v1/search/saved/groups/`
 *
 * Returns paginated list of search groups
 *
 * Required roles:
 *  - can_read_saved_searches
 *
 * Responses
 * - 200 - Returns a list of groups info
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Page number does not exist
 *
 * Response {@link SearchSavedSearchGroupsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/get_v1_search_saved_groups_}
 */
export const httpGetSearchSavedGroups = (
  query?: SearchHttpGetSearchSavedGroupsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpGetSearchSavedGroups,
  method: httpMethod.get,
  url: '/API/search/v1/search/saved/groups/',

  query,
  headers,
});

/**
 * `POST /v1/search/saved/groups/{group_id}/reindex/`
 *
 * Reindex a particular saved search group by id
 *
 * Required roles:
 *  - can_reindex_saved_searches
 *
 * Responses
 * - 201 - Returns a job info
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Group does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/post_v1_search_saved_groups__group_id__reindex_}
 */
export const httpPostSearchSavedGroupsByGroupIdReindex = (
  groupId: string,
  body: SearchReindexSavedSearchGroupSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPostSearchSavedGroupsByGroupIdReindex,
  method: httpMethod.post,
  url: `/API/search/v1/search/saved/groups/${encodeURIComponent(groupId)}/reindex/`,
  params: { groupId },
  body,
  headers,
});

/**
 * `DELETE /v1/search/saved/{search_id}/`
 *
 * Delete a saved search by its id
 *
 * Required roles:
 *  - can_delete_saved_searches
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Saved search does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/delete_v1_search_saved__search_id__}
 */
export const httpDeleteSearchSavedBySearchId = (
  searchId: string,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpDeleteSearchSavedBySearchId,
  method: httpMethod.delete,
  url: `/API/search/v1/search/saved/${encodeURIComponent(searchId)}/`,
  params: { searchId },
  headers,
});

export interface SearchHttpGetSearchSavedBySearchIdQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * Set to false if you only want the search definition
   */
  include_results?: boolean;
  /**
   * Set to true if you want to generate signed download urls
   */
  generate_signed_download_url?: boolean;
  /**
   * Set to true if you want to generate signed proxy urls
   */
  generate_signed_proxy_url?: boolean;
  /**
   * If true passed then uses scroll pagination instead of default one
   */
  scroll?: boolean;
  /**
   * In order to get next batch of results using scroll pagination the scroll_id is required
   */
  scroll_id?: string;
  /**
   * A serialised list of values from _sort field of a last returned record (encoded). For example - [1729527028527, "fd273ce8-8fc6-11ef-a762-cac08d6e9f12"]
   */
  search_after?: {};
  /**
   * Comma-separated list of asset types to include in results. Defaults to all except POST.
   *
   */
  types?: string;
}

/**
 * `GET /v1/search/saved/{search_id}/`
 *
 * Returns results of saved search
 *
 * Required roles:
 *  - can_read_saved_searches
 *
 * Responses
 * - 200 - Returns results of saved search
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Saved search does not exist
 * - 422 - The search query was rejected by Elasticsearch
 *
 * Response {@link SearchSavedSearchResultsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/get_v1_search_saved__search_id__}
 */
export const httpGetSearchSavedBySearchId = (
  searchId: string,
  query?: SearchHttpGetSearchSavedBySearchIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpGetSearchSavedBySearchId,
  method: httpMethod.get,
  url: `/API/search/v1/search/saved/${encodeURIComponent(searchId)}/`,
  params: { searchId },
  query,
  headers,
});

export type SearchSavedSearchSchemaPartial = Partial<SearchSavedSearchSchema>;

/**
 * `PATCH /v1/search/saved/{search_id}/`
 *
 * Search and save this search
 *
 * Required roles:
 *  - can_write_saved_searches
 *
 * Responses
 * - 200 - Returns the updated saved search
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Saved search does not exist
 *
 * Response {@link SearchSavedSearchSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/patch_v1_search_saved__search_id__}
 */
export const httpPatchSearchSavedBySearchId = (
  searchId: string,
  body: SearchSavedSearchSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPatchSearchSavedBySearchId,
  method: httpMethod.patch,
  url: `/API/search/v1/search/saved/${encodeURIComponent(searchId)}/`,
  params: { searchId },
  body,
  headers,
});

/**
 * `PUT /v1/search/saved/{search_id}/`
 *
 * Search and save this search
 *
 * Required roles:
 *  - can_write_saved_searches
 *
 * Responses
 * - 200 - Returns the updated saved search
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Saved search does not exist
 *
 * Response {@link SearchSavedSearchSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/put_v1_search_saved__search_id__}
 */
export const httpPutSearchSavedBySearchId = (
  searchId: string,
  body: SearchSavedSearchSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPutSearchSavedBySearchId,
  method: httpMethod.put,
  url: `/API/search/v1/search/saved/${encodeURIComponent(searchId)}/`,
  params: { searchId },
  body,
  headers,
});

export interface SearchHttpGetSearchSavedBySearchIdContentInfoQuery {
  /**
   * Compute total size only for files with the specified format name (default - ORIGINAL)
   */
  format_name?: string;
  /**
   * Group results by storage_id / storage_method
   */
  by_storage_id?: boolean;
}

/**
 * `GET /v1/search/saved/{search_id}/content/info/`
 *
 * Get aggregated information about saved search results
 *
 * <br/>The returned information includes count of assets and collections,<br/>total size of all assets (in bytes) and total duration of video and audio<br/>assets (in milliseconds).<br/>The returned information includes count of assets and collections,<br/>total size of all assets (in bytes) and total duration of video and audio<br/>assets (in milliseconds).
 * Required roles:
 *  - can_read_saved_searches
 *
 * Responses
 * - 200 - Returns aggregated information about the saved search results
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Saved search does not exist
 * - 422 - The search query was rejected by Elasticsearch
 *
 * Response {@link SearchSearchContentInfoSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/get_v1_search_saved__search_id__content_info_}
 */
export const httpGetSearchSavedBySearchIdContentInfo = (
  searchId: string,
  query?: SearchHttpGetSearchSavedBySearchIdContentInfoQuery,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpGetSearchSavedBySearchIdContentInfo,
  method: httpMethod.get,
  url: `/API/search/v1/search/saved/${encodeURIComponent(searchId)}/content/info/`,
  params: { searchId },
  query,
  headers,
});

/**
 * `POST /v1/search/saved/{search_id}/convert_to_collection/`
 *
 * Converts the saved search to a collection
 *
 * Required roles:
 *  - can_read_saved_searches
 * - can_create_collections
 * - can_write_collections
 *
 * Responses
 * - 202 - Schedules all the objects of the saved search to be added to a collection
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Access denied
 * - 404 - Saved search / Collection does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/post_v1_search_saved__search_id__convert_to_collection_}
 */
export const httpPostSearchSavedBySearchIdConvertToCollection = (
  searchId: string,
  body: SearchSavedSearchConvertCollectionSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPostSearchSavedBySearchIdConvertToCollection,
  method: httpMethod.post,
  url: `/API/search/v1/search/saved/${encodeURIComponent(searchId)}/convert_to_collection/`,
  params: { searchId },
  body,
  headers,
});

/**
 * `POST /v1/search/saved/{search_id}/reindex/`
 *
 * Reindex a particular saved search by id
 *
 * Required roles:
 *  - can_reindex_saved_searches
 *
 * Responses
 * - 201 - Returns a job
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Saved search does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/post_v1_search_saved__search_id__reindex_}
 */
export const httpPostSearchSavedBySearchIdReindex = (
  searchId: string,
  body: SearchReindexSavedSearchSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPostSearchSavedBySearchIdReindex,
  method: httpMethod.post,
  url: `/API/search/v1/search/saved/${encodeURIComponent(searchId)}/reindex/`,
  params: { searchId },
  body,
  headers,
});

/**
 * `POST /v1/search/suggest/`
 *
 * Returns search suggestions for a particular query.
 *
 * Required roles:
 *  - can_search
 *
 * Responses
 * - 200 - Returns search suggestions for a particular query.
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link SearchSearchSuggestsResponseSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/post_v1_search_suggest_}
 */
export const httpPostSearchSuggest = (
  body: SearchSearchSuggestSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPostSearchSuggest,
  method: httpMethod.post,
  url: '/API/search/v1/search/suggest/',

  body,
  headers,
});

/**
 * `DELETE /v1/views/`
 *
 * Delete Views for the system domain.
 *
 * Required roles:
 *  - can_delete_search_views
 *
 * Responses
 * - 200 - Delete was successful
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - All Views missing or not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/delete_v1_views_}
 */
export const httpDeleteViews = (
  body: SearchSearchViewsIDSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpDeleteViews,
  method: httpMethod.delete,
  url: '/API/search/v1/views/',

  body,
  headers,
});

/**
 * `GET /v1/views/`
 *
 * Get all Views for the system domain.
 *
 * Required roles:
 *  - can_read_search_views
 *
 * Responses
 * - 200 - Returns all Views
 * - 204 - No Views found
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link SearchSearchViewsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/get_v1_views_}
 */
export const httpGetViews = (headers?: IconikApiHeaders) => ({
  id: SearchHttpGetViews,
  method: httpMethod.get,
  url: '/API/search/v1/views/',

  headers,
});

/**
 * `POST /v1/views/`
 *
 * Insert a View for the system domain.
 *
 * Required roles:
 *  - can_write_search_views
 *
 * Responses
 * - 201 - Returns a View
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link SearchSearchViewSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/post_v1_views_}
 */
export const httpPostViews = (
  body: SearchSearchViewSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPostViews,
  method: httpMethod.post,
  url: '/API/search/v1/views/',

  body,
  headers,
});

/**
 * `DELETE /v1/views/{view_id}/`
 *
 * Delete a View for the system domain.
 *
 * Required roles:
 *  - can_delete_search_views
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - View is missing or not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/delete_v1_views__view_id__}
 */
export const httpDeleteViewsByViewId = (
  viewId: string,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpDeleteViewsByViewId,
  method: httpMethod.delete,
  url: `/API/search/v1/views/${encodeURIComponent(viewId)}/`,
  params: { viewId },
  headers,
});

/**
 * `GET /v1/views/{view_id}/`
 *
 * Get a View for the system domain.
 *
 * Required roles:
 *  - can_read_search_views
 *
 * Responses
 * - 200 - Returns a View
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - View is missing or not found
 *
 * Response {@link SearchSearchViewSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/get_v1_views__view_id__}
 */
export const httpGetViewsByViewId = (
  viewId: string,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpGetViewsByViewId,
  method: httpMethod.get,
  url: `/API/search/v1/views/${encodeURIComponent(viewId)}/`,
  params: { viewId },
  headers,
});

/**
 * `PUT /v1/views/{view_id}/`
 *
 * Replace a View for the system domain.
 *
 * Required roles:
 *  - can_write_search_views
 *
 * Responses
 * - 200 - Returns a View
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - View is missing or not found
 *
 * Response {@link SearchSearchViewSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/put_v1_views__view_id__}
 */
export const httpPutViewsByViewId = (
  viewId: string,
  body: SearchSearchViewSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPutViewsByViewId,
  method: httpMethod.put,
  url: `/API/search/v1/views/${encodeURIComponent(viewId)}/`,
  params: { viewId },
  body,
  headers,
});

/**
 * `POST /v2/nltf_parse/`
 *
 * NLTF Parse
 *
 * Required roles:
 * - can_search
 * - can_search_with_ai
 *
 * Responses
 * - 200 - Parsed natural-language query
 * - 400 - Bad request
 * - 403 - Forbidden
 * - 422 - Validation Error
 * - 429 - Too many requests
 * - 500 - Internal server error
 * - 502 - Upstream service error
 * - 503 - Service unavailable
 *
 * Response {@link SearchNltfParseResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/post_v2_nltf_parse_}
 */
export const httpPostV2NltfParse = (
  body: SearchNltfParseRequest,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPostV2NltfParse,
  method: httpMethod.post,
  url: '/API/search/v2/nltf_parse/',

  body,
  headers,
});

/**
 * `GET /v2/ping/`
 *
 * Routing health check
 *
 * Lightweight endpoint to verify gateway routing to search-v2.
 *
 * Responses
 * - 200 - Successful Response
 *
 * Response {@link SearchPingResponseNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/get_v2_ping_}
 */
export const httpGetV2Ping = (headers?: IconikApiHeaders) => ({
  id: SearchHttpGetV2Ping,
  method: httpMethod.get,
  url: '/API/search/v2/ping/',

  headers,
});

export interface SearchHttpPostV2SearchQuery {
  per_page?: number;
  page?: number;
  scroll?: boolean;
  scroll_id?: string;
  generate_signed_url?: boolean;
  generate_signed_download_url?: boolean;
  generate_signed_proxy_url?: boolean;
  save_search_history?: boolean;
  types?: string;
  include_users?: boolean;
}

/**
 * `POST /v2/search/`
 *
 * Search
 *
 * Required roles:
 * - can_search
 *
 * Responses
 * - 200 - Returns the result of search
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Not found
 * - 422 - Validation Error
 * - 500 - Internal server error
 * - 504 - Gateway timeout
 *
 * Response {@link SearchSearchDocumentsResponseWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/post_v2_search_}
 */
export const httpPostV2Search = (
  body: SearchSearchCriteria,
  query?: SearchHttpPostV2SearchQuery,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPostV2Search,
  method: httpMethod.post,
  url: '/API/search/v2/search/',

  body,
  query,
  headers,
});

export interface SearchHttpPostV2SearchNaturalQuery {
  generate_signed_url?: boolean;
  generate_signed_download_url?: boolean;
  generate_signed_proxy_url?: boolean;
  include_users?: boolean;
}

/**
 * `POST /v2/search/natural/`
 *
 * Natural language search
 *
 * Required roles:
 * - can_search
 *
 * Responses
 * - 200 - Natural-search results and the filters that produced them
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 422 - Validation Error
 * - 504 - Gateway timeout
 *
 * Response {@link SearchNaturalSearchResponseWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/post_v2_search_natural_}
 */
export const httpPostV2SearchNatural = (
  body: SearchNaturalSearchRequest,
  query?: SearchHttpPostV2SearchNaturalQuery,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPostV2SearchNatural,
  method: httpMethod.post,
  url: '/API/search/v2/search/natural/',

  body,
  query,
  headers,
});

/**
 * `POST /v2/search/suggest/`
 *
 * Search suggestions
 *
 * Required roles:
 * - can_search
 *
 * Responses
 * - 200 - Returns search suggestions for a particular query
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 422 - Validation Error
 *
 * Response {@link SearchSearchSuggestsResponseWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/post_v2_search_suggest_}
 */
export const httpPostV2SearchSuggest = (
  body: SearchSearchSuggestRequest,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPostV2SearchSuggest,
  method: httpMethod.post,
  url: '/API/search/v2/search/suggest/',

  body,
  headers,
});

/**
 * `GET /v2/search_backends/`
 *
 * List the configured search backends of the domain
 *
 * Required roles:
 * - can_read_search_backends
 *
 * Responses
 * - 200 - Configured search backends
 * - 401 - Token is invalid
 * - 403 - Forbidden
 * - 422 - Validation Error
 * - 503 - Service unavailable
 *
 * Response {@link SearchSearchBackendsListSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/get_v2_search_backends_}
 */
export const httpGetV2SearchBackends = (headers?: IconikApiHeaders) => ({
  id: SearchHttpGetV2SearchBackends,
  method: httpMethod.get,
  url: '/API/search/v2/search_backends/',

  headers,
});

/**
 * `POST /v2/search_backends/`
 *
 * Configure a new search backend for the domain
 *
 * Required roles:
 * - can_write_search_backends
 *
 * Responses
 * - 201 - The created search backend
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Forbidden
 * - 422 - Validation Error
 * - 503 - Service unavailable
 *
 * Response {@link SearchSearchBackendReadSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/post_v2_search_backends_}
 */
export const httpPostV2SearchBackends = (
  body: SearchSearchBackendCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPostV2SearchBackends,
  method: httpMethod.post,
  url: '/API/search/v2/search_backends/',

  body,
  headers,
});

/**
 * `GET /v2/search_backends/kinds/`
 *
 * List the installed search backend kinds and their options schemas
 *
 * Required roles:
 * - can_read_search_backends
 *
 * Responses
 * - 200 - Installed backend kinds
 * - 401 - Token is invalid
 * - 403 - Forbidden
 *
 * Response {@link SearchKindsListSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/get_v2_search_backends_kinds_}
 */
export const httpGetV2SearchBackendsKinds = (headers?: IconikApiHeaders) => ({
  id: SearchHttpGetV2SearchBackendsKinds,
  method: httpMethod.get,
  url: '/API/search/v2/search_backends/kinds/',

  headers,
});

/**
 * `DELETE /v2/search_backends/{backend_id}/`
 *
 * Delete a configured search backend
 *
 * Required roles:
 * - can_delete_search_backends
 *
 * Responses
 * - 204 - The search backend was deleted
 * - 401 - Token is invalid
 * - 403 - Forbidden
 * - 404 - Not found
 * - 422 - Validation Error
 * - 503 - Service unavailable
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/delete_v2_search_backends__backend_id__}
 */
export const httpDeleteV2SearchBackendsByBackendId = (
  backendId: string,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpDeleteV2SearchBackendsByBackendId,
  method: httpMethod.delete,
  url: `/API/search/v2/search_backends/${encodeURIComponent(backendId)}/`,
  params: { backendId },
  headers,
});

/**
 * `GET /v2/search_backends/{backend_id}/`
 *
 * Get one configured search backend
 *
 * Required roles:
 * - can_read_search_backends
 *
 * Responses
 * - 200 - The configured search backend
 * - 401 - Token is invalid
 * - 403 - Forbidden
 * - 404 - Not found
 * - 422 - Validation Error
 * - 503 - Service unavailable
 *
 * Response {@link SearchSearchBackendReadSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/get_v2_search_backends__backend_id__}
 */
export const httpGetV2SearchBackendsByBackendId = (
  backendId: string,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpGetV2SearchBackendsByBackendId,
  method: httpMethod.get,
  url: `/API/search/v2/search_backends/${encodeURIComponent(backendId)}/`,
  params: { backendId },
  headers,
});

export type SearchSearchBackendUpdateSchemaPartial =
  Partial<SearchSearchBackendUpdateSchema>;

/**
 * `PATCH /v2/search_backends/{backend_id}/`
 *
 * Update a configured search backend
 *
 * Required roles:
 * - can_write_search_backends
 *
 * Responses
 * - 200 - The updated search backend
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Forbidden
 * - 404 - Not found
 * - 422 - Validation Error
 * - 503 - Service unavailable
 *
 * Response {@link SearchSearchBackendReadSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/patch_v2_search_backends__backend_id__}
 */
export const httpPatchV2SearchBackendsByBackendId = (
  backendId: string,
  body: SearchSearchBackendUpdateSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPatchV2SearchBackendsByBackendId,
  method: httpMethod.patch,
  url: `/API/search/v2/search_backends/${encodeURIComponent(backendId)}/`,
  params: { backendId },
  body,
  headers,
});

/**
 * `PUT /v2/search_backends/{backend_id}/`
 *
 * Replace a configured search backend
 *
 * Required roles:
 * - can_write_search_backends
 *
 * Responses
 * - 200 - The updated search backend
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Forbidden
 * - 404 - Not found
 * - 422 - Validation Error
 * - 503 - Service unavailable
 *
 * Response {@link SearchSearchBackendReadSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/put_v2_search_backends__backend_id__}
 */
export const httpPutV2SearchBackendsByBackendId = (
  backendId: string,
  body: SearchSearchBackendUpdateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPutV2SearchBackendsByBackendId,
  method: httpMethod.put,
  url: `/API/search/v2/search_backends/${encodeURIComponent(backendId)}/`,
  params: { backendId },
  body,
  headers,
});

/**
 * `POST /v2/search_backends/{backend_id}/test/`
 *
 * Test a configured search backend against its remote provider
 *
 * Required roles:
 * - can_write_search_backends
 *
 * Responses
 * - 200 - The connection test outcome
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Forbidden
 * - 404 - Not found
 * - 422 - Validation Error
 * - 503 - Service unavailable
 *
 * Response {@link SearchConnectionTestSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/search/spec/#/default/post_v2_search_backends__backend_id__test_}
 */
export const httpPostV2SearchBackendsByBackendIdTest = (
  backendId: string,
  headers?: IconikApiHeaders,
) => ({
  id: SearchHttpPostV2SearchBackendsByBackendIdTest,
  method: httpMethod.post,
  url: `/API/search/v2/search_backends/${encodeURIComponent(backendId)}/test/`,
  params: { backendId },
  headers,
});
